(function() {
	'use strict';

	angular.module('requestApp').controller('FileTemplateController',
			FileTemplateController);

	FileTemplateController.$inject = [ '$timeout', 'FileTemplateService',
			'$state', '$http', '$scope', '$uibModal', 'GLOBAL_URL', 'Upload',
			'authExpiredInterceptor', '$base64', '$rootScope', '$window',
			'$stateParams', 'CommonService', 'QUESTIONNAIRE_8',
			'QUESTIONNAIRE_5', 'RELATIONSHIP_TYPE', 'RIGHTS_EDUCATION',
			'PAPER_TYPE' ];

	function FileTemplateController($timeout, FileTemplateService, $state,
			$http, $scope, $uibModal, GLOBAL_URL, Upload,
			authExpiredInterceptor, $base64, $rootScope, $window, $stateParams,
			CommonService, QUESTIONNAIRE_8, QUESTIONNAIRE_5, RELATIONSHIP_TYPE,
			RIGHTS_EDUCATION, PAPER_TYPE) {

		var vm = this;
		vm.flgCheckIdNumLA = false;
		vm.flagEUS5 = false;
		vm.flagAgeValidate = false;
		vm.sioCampaign = false;
		vm.isResultError=false;
		vm.isResultSuccess=false;
		vm.searchPruquote = false;
		var self = $scope;
		var checked = 0;
		vm.list8 = QUESTIONNAIRE_8;
		vm.list5 = QUESTIONNAIRE_5;
		vm.relationShipTypes = RELATIONSHIP_TYPE;
		vm.rightsEducations = RIGHTS_EDUCATION;
		vm.paperTypes = PAPER_TYPE;
		vm.choices1 = [];
		vm.choices2 = [];
		vm.choices3 = [];
		vm.choices4 = [];
		vm.filesByPaperType = [];
		vm.archiveDataIds = [];
		vm.validDsrOpw = true;
		vm.msgDsrOpw = '';

		var currentDate = new Date();
		currentDate.setHours(0,0,0,0)
		var tDate = new Date("04/23/2024")
		if(tDate <= currentDate
			&& document.getElementById("fileTemplateHotlink") != null
			&& document.getElementById("fileTemplateHotlink") != undefined)
		{
			document.getElementById("fileTemplateHotlink").style.display = "none";
		}

		// Get type of organization
		self.typeOfOrganizations = CommonService.query({
			masterurl : 'organization-type'
		});
		/*
		 * Loại hình tổ chức/ doanh nghiệp = “Tổ chức tài chính” / “Quỹ tín
		 * thác”, 2 op neu chon la co ====> show warning
		 */
		vm.showWarning = function(value) {
			self.clearMessage();
			if (value != 'OTHER') {
				self.addAlert('Kiểm tra lại với tư vấn viên thông tin này.',
						'warning');
			}
		};

		vm.showWarningEntity = function(value) {
			self.clearMessage();
			if (value == "1") {
				self.addAlert('Kiểm tra lại với tư vấn viên thông tin này.',
						'warning');
			}
		};

		vm.showWarningUsBenOwer = function(value) {
			self.clearMessage();
			if (value == "1") {
				self.addAlert('Kiểm tra lại với tư vấn viên thông tin này.',
						'warning');
			}
		};

		$scope.$watch('form', function(form) {
			vm.validateForm = form;
		});

		vm.proposal = {
			proposalNum : ''
		};
		vm.param = {};
		vm.firstLoad = true;

		//Add days
		Date.prototype.AddDays = function(noOfDays) {
			this.setTime(this.getTime() + (noOfDays * (1000 * 60 * 60 * 24)));
			return this;
		};

		vm.getProposalInfo = function() {
			var currentDate = new Date();
			currentDate.setHours(0,0,0,0)
			var tDate = new Date("04/23/2024")
			if(tDate.AddDays(-7) <= currentDate
				&& tDate.AddDays(6) >= currentDate)
			{
				tDate.AddDays(1);
				var stringTDate =  ((tDate.getDate() > 9) ? tDate.getDate() : ('0' + tDate.getDate())) +  '/' + ((tDate.getMonth() > 8) ? (tDate.getMonth() + 1) : ('0' + (tDate.getMonth() + 1))) +'/' + tDate.getFullYear();
				self.addAlert('Kể từ ngày ' + stringTDate + ', hệ thống sẽ không cho phép thực hiện tiếp nhận và nhập thông tin HSYCBH bản giấy. Anh/Chị lưu ý hoàn tất việc nộp HSYCBH bản giấy về Prudential trước ngày '+ stringTDate + ' cũng như thông báo đến Tư vấn viên. Sau ngày ' + stringTDate + ', Anh/chị vui lòng sử dụng hệ thống Prudaily để điền và nộp HSYCBH. Cám ơn sự hợp tác của các Anh/Chị. Trân Trọng','warning');
			}
			FileTemplateService.get({
				uri : 'initPage'
			}, function(result) {
				vm.proposal = result;
				initPage1(vm, self);
				initPage2(vm, FileTemplateService, self);
				initPage3(vm);
				initPage4(vm, FileTemplateService, self);
				initPage5(vm, self);
				initPage6(vm);
				initPage7(vm, FileTemplateService, self);
				initPage8(vm);
				initPage9(vm, FileTemplateService, self);
				vm.proposal.receiptDate = null;
				InitPage();
				if ($stateParams.proposalNum !== undefined
						&& $stateParams.proposalNum !== null) {
					var proposalNum = $base64.decode($stateParams.proposalNum);
					var txnId = $base64.decode($stateParams.txnId);
					if (vm.firstLoad) {
						vm.proposal.proposalNum = proposalNum;
						vm.proposal.txnId = txnId;
						vm.searchByProposalNum();
					}
				}
			});
		}

		vm.occupation = [];
		vm.getOccupation = function() {
			FileTemplateService.query({
				uri : 'getOccupations'
			}, function(result) {
				vm.occupation = result;

			});
		};

		vm.listNationality = [];
		vm.getNationality = function() {
			FileTemplateService.query({
				uri : 'getNationality'
			}, function(result) {
				vm.listNationality = result;
			});
		};

		$scope.listHinhThucHoTro = ['Hội thảo tư vấn, giới thiệu, bán sản phẩm bảo hiểm',
			'Cùng TVV trực tiếp tư vấn, giới thiệu, bán sản phẩm bảo hiểm',
			'Hỗ trợ TVV qua điện thoại',
			'Hỗ trợ TVV qua email ',
			'Hỗ trợ TVV qua hình thức khác '];

		vm.getPhoneCode = function() {
			FileTemplateService.query({
				uri : 'getPhoneCode'
			}, function(result) {
				vm.listPhoneCode = result;
			});
		};

		vm.getListEducation = function() {
			FileTemplateService.query({
				uri : 'getEducationItems'
			}, function(result) {
				vm.listEducation = result;
			});
		};

		vm.province = [];
		vm.getProvince = function() {
			FileTemplateService.query({
				uri : 'getProvinceList'
			}, function(result) {
				vm.province = result;
			});
		};
		$scope.format = 'dd/MM/yyyy';
		$scope.currentDate = new Date();
		vm.altInputFormats = [ 'M!/d!/yyyy' ];

		vm.maxlength = 2;

		vm.urlContent = "";
		vm.index = "0";
		vm.success = null;
		vm.showExcess = false;
		vm.searchByProposalNum = function() {
			vm.firstLoad = false;
			if (vm.proposal.proposalNum != undefined
					&& vm.proposal.proposalNum != null
					&& vm.proposal.proposalNum != '') {
				FileTemplateService
						.get(
								{
									uri : 'proposalNum',
									proposalNum : vm.proposal.proposalNum
								},
								function(result) {
									if (result.proposalNum === undefined
											|| result.proposalNum === null) {
										$scope.clearMessage();
										self.addAlert(
												'Số hồ sơ không tồn tại.',
												'danger');
										return;
									}
									vm.proposal = result;
									vm.attachmentLiberty = [];
									vm.attachmentLiberty.content = result.attachmentLiberty;
									vm.attachmentLiberty.name = result.attachmentLibertyName;
									vm.attachmentLiberty.type = result.attachmentLibertyType;
									if (result.attachments != null) {
										for (var int = 0; int < result.attachments.length; int++) {
											var file = {};
											file.name = result.attachments[int].dataName;
											file.size = result.attachments[int].contentType;
											file.type = result.attachments[int].dataType;
											file.archiveDataId = result.attachments[int].archiveDataId;
											if (result.attachments[int].paperType != null
													&& result.attachments[int].paperType != undefined) {
												var obj = {
													'file' : file,
													'paperType' : result.attachments[int].paperType,
													'paperTypeName' : getNameDropDownList(result.attachments[int].paperType)
												};
												vm.filesByPaperType.push(obj);
											} else {
												vm.filesByPaperType = [];
												var obj = {
													'file' : file,
													'paperType' : result.attachments[0].paperType,
													'paperTypeName' : getNameDropDownList(result.attachments[0].paperType)
												};
												vm.filesByPaperType.push(obj);
												break;
											}

										}

									}
									vm.loadquestion8();
									vm.getBenefitItems();
									// vm.attachment.name =
									// vm.proposal.dataName;

									if ((
										// vm.proposal.contractType === 'VL6' ||
										(vm.proposal.contractType === 'VL5'
												&& (vm.proposal.productName.toUpperCase().trim !== 'Sản phẩm bảo hiểm liên kết chung PRU- VỮNG CHẮC'.toUpperCase().trim ))
									   && (vm.proposal.agentCode.startsWith('69') || vm.proposal.agentCode.startsWith('60')))) {
										vm.resetProposal();
										$scope.clearMessage();
										self
											.addAlert(
												'Hồ sơ được tạo quá thời hạn cho phép. Vui lòng kiểm tra lại',
												'danger');
										return;
									}

									if (vm.proposal.contractType === 'RO1'
											|| vm.proposal.contractType === 'VL4'
											|| vm.proposal.contractType === 'IP1') {
										vm.resetProposal();
										$scope.clearMessage();
										self
												.addAlert(
														'Hệ thống chưa hỗ trợ tạo hợp đồng dự thảo cho sản phẩm này.',
														'danger');
										return;
									}
									if (vm.proposal.contractType === 'VL5') {
										vm.maxlength = 3;
									}
									if (vm.proposal.contractType === 'EU5') {
										vm.flagEUS5 = true;
									}
									// if
									// (vm.proposal.contractType.includes("VL"))
									// {
									if (vm.proposal.contractType.indexOf("VL") !== -1) {
										vm.showExcess = true;
									}

									$scope.isDisabled = true;
									if (vm.proposal.agentCode !== null) {
										vm.searchAgent(1);
									} else {
										vm.agentName = null;
									}
									if (vm.proposal.sharedAgentCode !== null) {
										vm.searchAgent(2);
									} else {
										vm.sharedAgentName = null;
									}

									if(vm.proposal.hthtDirectLead !== null)
									{
										vm.proposal.lisththtDirectLead = vm.proposal.hthtDirectLead.split(",");
									}

									if(vm.proposal.hthtInDirectLead !== null)
									{
										vm.proposal.lisththtInDirectLead = vm.proposal.hthtInDirectLead.split(",");
									}

									vm.defaultPage2();
									vm.defaultPage4();
									vm.defaultPage7();
									vm.getRiderQuotation();

									// khong copy khi da check po is la sau khi
									// load tu db
									if (vm.proposal.isPoLa == '2') {
										vm.PoIsBHBS = true;
										checked = 1;
										/*
										 * angular.copy(vm.proposal.po.customer,
										 * vm.proposal.laList[1].customer);
										 */
									} else if (vm.proposal.isPoLa == '1') {
										vm.PoIsLA = true;
										checked = 2;
										/*
										 * angular.copy(vm.proposal.po.customer,
										 * vm.proposal.laList[0].customer);
										 */
									}
									if(vm.proposal.po.customer.faoAddress != undefined
										&& vm.proposal.po.customer.faoAddress != null)
									{
										if(vm.proposal.po.customer.faoAddress.provinceCode != undefined
											&& vm.proposal.po.customer.faoAddress.provinceCode != null
											&& vm.proposal.po.customer.faoAddress.provinceCode != '')
										{
											vm.getProvince();
											vm.provinceCodeFAO = vm.proposal.po.customer.faoAddress.provinceCode;

											if(vm.proposal.po.customer.faoAddress.districtCode != undefined
												&& vm.proposal.po.customer.faoAddress.districtCode != null
												&& vm.proposal.po.customer.faoAddress.districtCode != '')
											{
												vm.getDistrict(vm.provinceCodeFAO,8);
												vm.districtCodeFAO = vm.proposal.po.customer.faoAddress.districtCode;
											}
											if(vm.proposal.po.customer.faoAddress.wardCode != undefined
												&& vm.proposal.po.customer.faoAddress.wardCode != null
												&& vm.proposal.po.customer.faoAddress.wardCode != '')
											{
												vm.getWard(vm.districtCodeFAO,8);
											}
										}
									}

									if(vm.proposal.po.bankAccountCode != undefined
											&& vm.proposal.po.bankAccountCode != null
											&& vm.proposal.po.bankAccountCode != '') {
											vm.getBranchBank();
										}
									if (vm.proposal.po.addressVN.provinceCode != null) {
										vm
												.getDistrict(
														vm.proposal.po.addressVN.provinceCode,
														3);
									}
									if (vm.proposal.po.addressVN.districtCode != undefined
											&& vm.proposal.po.addressVN.districtCode !== null) {
										vm
												.getWard(
														vm.proposal.po.addressVN.districtCode,
														3);
									}

									if (vm.proposal.po.customer.locationCode !== undefined
											&& vm.proposal.po.customer.locationCode !== null
											&& vm.proposal.po.customer.locationCode.length >= 6) {
										var locationCode = vm.proposal.po.customer.locationCode;
										if (vm.proposal.po.poType == 'C') { // to
											// chuc
											var province = locationCode
													.substring(0, 2);
											vm.provinceForeignAddressPO = province;
											vm.getDistrict(province, 1);
											var district = locationCode
													.substring(0, 4);
											vm.districtForeignAddressPO = district;
											vm.getWard(district, 1);
										} else if (vm.proposal.po.poType == 'P') { // ca
											// nhan
											var province = locationCode
													.substring(0, 2);
											vm.provinceForeignAddressPO = province;
											vm.getDistrict(province, 2);
											var district = locationCode
													.substring(0, 4);
											vm.districtForeignAddressPO = district;
											vm.getWard(district, 2);
										}
									}
									if (vm.proposal.alternativeAddress.street !== undefined
											&& vm.proposal.alternativeAddress.street !== null
											&& vm.proposal.alternativeAddress.street !== '') {
										vm.checkAlternaitve = true;
										vm.checkAlternativeAddress();
									} else {
										vm.checkAlternaitve = false;
										vm.checkAlternativeAddress();
									}
									if (vm.proposal.laList[0].customer.locationCode !== undefined
											&& vm.proposal.laList[0].customer.locationCode !== null
											&& vm.proposal.laList[0].customer.locationCode.length >= 6) {
										var locationCode = vm.proposal.laList[0].customer.locationCode;
										var province = locationCode.substring(
												0, 2);
										vm.provinceMainLA = province;
										vm.getDistrict(province, 4);
										var district = locationCode.substring(
												0, 4);
										vm.districtMainLA = district;
										vm.getWard(district, 4);
									}
									if (vm.proposal.laList[1].customer.locationCode !== undefined
											&& vm.proposal.laList[1].customer.locationCode !== null
											&& vm.proposal.laList[1].customer.locationCode.length >= 6) {
										var locationCode = vm.proposal.laList[1].customer.locationCode;
										var province = locationCode.substring(
												0, 2);
										vm.provincesubLA = province;
										vm.getDistrict(province, 5);
										var district = locationCode.substring(
												0, 4);
										vm.districtsubLA = district;
										vm.getWard(district, 5);
									}
									if (vm.proposal.laList[2].customer.locationCode !== undefined
											&& vm.proposal.laList[2].customer.locationCode !== null
											&& vm.proposal.laList[2].customer.locationCode.length >= 6) {
										var locationCode = vm.proposal.laList[2].customer.locationCode;
										var province = locationCode.substring(
												0, 2);
										vm.provincethirdLA = province;
										vm.getDistrict(province, 6);
										var district = locationCode.substring(
												0, 4);
										vm.districtthirdLA = district;
										vm.getWard(district, 6);
									}
									if (vm.proposal.laList[3].customer.locationCode !== undefined
											&& vm.proposal.laList[3].customer.locationCode !== null
											&& vm.proposal.laList[3].customer.locationCode.length >= 6) {
										var locationCode = vm.proposal.laList[3].customer.locationCode;
										var province = locationCode.substring(
												0, 2);
										vm.provincefourthLA = province;
										vm.getDistrict(province, 7);
										var district = locationCode.substring(
												0, 4);
										vm.districtfourthLA = district;
										vm.getWard(district, 7);
									}
									if (vm.proposal.po.poType == 'C') {
										vm.relationShipLAMain = [ {
											code : '0000',
											name : 'Nhân viên'
										} ];
										vm.relationShipLASub1 = [ {
											code : '0000',
											name : 'Nhân viên'
										} ];
										vm.relationShipLASub2 = [ {
											code : '0000',
											name : 'Nhân viên'
										} ];
										vm.relationShipLASub3 = [ {
											code : '0000',
											name : 'Nhân viên'
										} ];
										vm.PoIsLA = false;
										vm.PoIsBHBS = false;
									} else if (vm.proposal.po.poType == 'P') {
										vm.loadQuanHe(1);
										vm.loadQuanHe(2);
										vm.loadQuanHe(3);
										vm.loadQuanHe(4);
										// 20180626: Default Từ 4.5 triệu đến
										// 7.5 triệu
										if (vm.proposal.po.incomeRange == null
												|| vm.proposal.po.incomeRange == undefined
												|| vm.proposal.po.incomeRange == '') {
											vm.proposal.po.incomeRange = '03';
										}
									}
									initPage3(vm);
									initPage6(vm);
									if(vm.proposal.quotationID != null && vm.proposal.proposalSaved=='N')
										vm.searchQuotation();
								}, function(err) {
									$scope.clearMessage();
									self.addAlert('Dữ liệu nhập bị lỗi.',
											'danger');
								});
			} else {
				return;
			}
		}

		vm.searchAgent = function(type) {

			if (type == 1) {
				var code = vm.proposal.agentCode;
				if (code == undefined || code == null || code == '') {
					vm.agentName = '';
					vm.isshowleader = false;
					vm.isshowqltt = false;
					vm.isshowqlgt = false;
					vm.isshowgdb = false;

					vm.proposal.nameDirectLead = '';
					vm.proposal.codeDirectLead = '';
					vm.proposal.phoneDirectLead = '';
					vm.proposal.hthtDirectLead = '';

					vm.proposal.nameInDirectLead = '';
					vm.proposal.codeInDirectLead = '';
					vm.proposal.phoneInDirectLead = '';
					vm.proposal.hthtInDirectLead = '';

					return;
				}
				if (code != undefined || code != '') {
					var numCode = Number(code);
					if (numCode < 10000000)
						numCode += 60000000;
					vm.proposal.agentCode = numCode.toString();
				}
				FileTemplateService.get({
					uri : 'get-agent',
					agentCode : vm.proposal.agentCode
				}, function(result) {
					vm.agentName = result.agentName;
					vm.mdrtpf1 = result.mdrtpf;
					vm.isshowleader = result.agentCode.startsWith("60") && (result.nameDirectLead != null
																			|| result.nameInDirectLead != null
																			|| result.nameBranchLead != null);
					vm.isshowqltt = result.agentCode.startsWith("60") && (result.nameDirectLead != null);
					vm.isshowqlgt = result.agentCode.startsWith("60") && (result.nameInDirectLead != null);

					vm.proposal.nameDirectLead = result.nameDirectLead;
					vm.proposal.codeDirectLead = result.codeDirectLead;
					vm.proposal.phoneDirectLead = result.phoneDirectLead;

					vm.proposal.nameInDirectLead = result.nameInDirectLead;
					vm.proposal.codeInDirectLead = result.codeInDirectLead;
					vm.proposal.phoneInDirectLead = result.phoneInDirectLead;
				});
			}
			else if (type == 2) {
				var code = vm.proposal.sharedAgentCode;
				if (code == undefined || code == null || code == '') {
					vm.sharedAgentName = '';
					return;
				}
				if (code != undefined || code != '') {
					var numCode = Number(code);
					if (numCode < 10000000)
						numCode += 60000000;
					vm.proposal.sharedAgentCode = numCode.toString();
				}
				FileTemplateService.get({
					uri : 'get-agent',
					agentCode : vm.proposal.sharedAgentCode
				}, function(result) {
					vm.sharedAgentName = result.agentName;
					vm.mdrtpf2 = result.mdrtpf;
				});
			}
			else if (type == 3) {
				var code = vm.proposal.codeDirectLead;
				if (code == undefined || code == null || code == '') {
					vm.proposal.nameDirectLead = '';
					vm.proposal.phoneDirectLead = '';
					return;
				}
				if (code != undefined || code != '') {
					var numCode = Number(code);
					if (numCode < 10000000)
						numCode += 60000000;
					vm.proposal.codeDirectLead = numCode.toString();
				}
				FileTemplateService.get({
					uri : 'get-agent',
					agentCode : vm.proposal.codeDirectLead
				}, function(result) {
					vm.proposal.nameDirectLead = result.agentName;
					vm.proposal.phoneDirectLead = result.phone01 == null ? result.phone02 : result.phone01;
				});
			}
			else if (type == 4) {
				var code = vm.proposal.codeInDirectLead;
				if (code == undefined || code == null || code == '') {
					vm.proposal.nameInDirectLead = '';
					vm.proposal.phoneInDirectLead = '';
					return;
				}
				if (code != undefined || code != '') {
					var numCode = Number(code);
					if (numCode < 10000000)
						numCode += 60000000;
					vm.proposal.codeInDirectLead = numCode.toString();
				}
				FileTemplateService.get({
					uri : 'get-agent',
					agentCode : vm.proposal.codeInDirectLead
				}, function(result) {
					vm.proposal.nameInDirectLead = result.agentName;
					vm.proposal.phoneInDirectLead = result.phone01 == null ? result.phone02 : result.phone01;
				});
			}
		}

		vm.changeTab = function(index) {
			if (vm.proposal !== undefined) {
				var hasError = false;
				if (hasError)
					return;
				if (vm.index == 7) {
					if (!vm.sioCampaign) {
						if (vm.validatePage7()) {
							return false;
						}
					}

				} else if (vm.index == 1) {
					$scope.clearMessage();
					var flag = vm.invalidTab1();
					if (flag || vm.flgCheckIdNumLA || vm.flagAgeValidate) {
						if (vm.flgCheckIdNumLA) {
							self.addAlert('Các LA bị trùng số ID.', 'danger');
						}
						return;
					}
				} else if (vm.index == 2) {
					if (vm.validatePage2()) {
						return false;
					}

				} else if (vm.index == 4 || vm.flagAgeValidate) {
					$scope.clearMessage();
					var flag = vm.validatePage4();
					if (flag || vm.flagAgeValidate) {
						return;
					}
				} else if (vm.index == 5) {
					$scope.clearMessage();
					var flag = vm.invalidTab5();
					if (flag || vm.flgCheckIdNumLA) {
						if (vm.flgCheckIdNumLA) {
							self.addAlert('Các LA bị trùng số ID.', 'danger');
						}
						return;
					}
				} else if (vm.index == 3) {
					if (vm.validatePage3()) {
						return false;
					}
				} else if (vm.index == 9) {
					if (vm.validatePage9()) {
						return false;
					}
				}
			}
			vm.indexOld = vm.index;
			vm.index = index;
			if (index === 1) {
				$state.go('fileTemplate.pageOne');
			} else if (index === 2) {
				$state.go('fileTemplate.pageTwo');
			} else if (index === 3) {
				vm.loadNationalTravel();
				$state.go('fileTemplate.pageThree');
			} else if (index === 4) {
				$state.go('fileTemplate.pageFour');
			} else if (index === 5) {
				$state.go('fileTemplate.pageFive');
			} else if (index === 6) {
				vm.loadNationalTravel();
				$state.go('fileTemplate.pageSix');
			} else if (index === 7) {
				$state.go('fileTemplate.pageSeven');
				vm.defaultPage7();
				vm.getRiderQuotation();
			} else if (index === 8) {
				$state.go('fileTemplate.pageEight');
			} else if (index === 9) {
				$state.go('fileTemplate.pageNine');
			} else if (index === 10) {
				// var modalInstance = $uibModal.open({
				// animation: $scope.animationsEnabled,
				// templateUrl: GLOBAL_URL
				// + 'partial?uri=ga/newbusiness/filetemplate/dialogConfirm',
				// controller: 'DialogConfirmController as confirmController',
				// size: 'mi',
				// resolve: {
				// }
				// });
				//
				// modalInstance.result.then(function (checkItem) {
				// if(checkItem){
				$state.go('fileTemplate.pageTen');
				// }
				// }, function () {
				// vm.changeTab(vm.indexOld)
				// });
			}

		}

		vm.popupDOIns = false;
		vm.popupDateReceipt = false;
		vm.popupDateOfBirthPO = false;
		vm.popupDateOfBirthLA = false;
		vm.popupDateOfBirthSubLA = false;

		$scope.dateOptions = {
			minDate : new Date(1900, 0, 1),
			maxDate : new Date()
		}
		$scope.ngayDuSinh = {
			minDate : new Date()
		}

		vm.openDatePicker = function(index) {
			if (index == 1) {
				vm.popupDOIns = true;
			} else if (index == 2) {
				vm.popupDateReceipt = true;
			} else if (index == 3) {
				vm.popupDateOfBirthPO = true;
			} else if (index == 4) {
				vm.popupDateOfBirthLA = true;
			} else if (index == 5) {
				vm.popupDateOfBirthThirdLA = true;
			} else if (index == 6) {
				vm.popupDateOfBirthFourthLA = true;
			} else if (index == 7) {
				vm.ngayDuSinh06 = true;
			} else if (index == 8) {
				vm.ngayDuSinh16 = true;
			} else if (index == 9) {
				vm.popupDateOfBirthSubLA = true;
			} else if (index == 10) {
				vm.ngayDuSinh1 = true;
			} else if (index == 11) {
				vm.ngayDuSinh0 = true;
			}
		};

		vm.calculaNumberYear = function(date, dob, type) {
			$scope.clearMessage();
			if (!moment(dob).isValid()) {
				return;
			}
			if (date === undefined || date === null || dob === undefined
					|| dob === null) {
				return;
			}
			if (vm.proposal.receiptDate === undefined
					|| vm.proposal.receiptDate === null
					|| vm.proposal.receiptDate === '') {
				if (type == 1) {
					vm.proposal.po.customer.dob = null;
				} else if (type == 2) {
					vm.proposal.laList[0].customer.dob = null;
				}
				return;
			}
			dob = new Date(dob).getTime();
			var dateNow = new Date(vm.proposal.receiptDate).getTime();
			if (dob > dateNow) {
				if (type == 1) {
					vm.proposal.po.customer.dob = null;
					vm.proposal.po.customer.age = null;
				} else if (type == 2) {
					vm.proposal.laList[0].customer.dob = null;
					vm.proposal.laList[0].customer.age = null;
				} else if (type === 3) {
					vm.proposal.laList[1].customer.dob = null;
					vm.proposal.laList[1].customer.age = null;
				} else if (type == 4) {
					vm.proposal.laList[2].customer.dob = null;
					vm.proposal.laList[2].customer.age = null;
				} else if (type === 5) {
					vm.proposal.laList[3].customer.dob = null;
					vm.proposal.laList[3].customer.age = null;
				}
				return;
			}

			FileTemplateService
					.get(
							{
								uri : 'calculateAge',
								birthMsDate : dob,
								trMsDate : vm.proposal.receiptDate
							},
							function(result) {
								if (result !== null) {
									if (type == 1) {
										if (result.age > 120) {
											self
													.addAlert(
															'Tuổi người mua bảo hiểm phải nhỏ hơn 120',
															'danger');
											vm.proposal.po.customer.age = null;
											vm.proposal.po.customer.dob = null;
											vm.flagAgeValidate = true;
										} else {
											vm.proposal.po.customer.age = result.age;
											// 20180626: On leave: tính tuổi của
											// client --> nếu tuổi ≤ 16 tuổi: hệ
											// thống điền giá trị "Độc thân" vô
											// field <Tình trạng hôn nhân>/"Tình
											// trạng gia đình"
											if (result.age <= 16) {
												vm.proposal.po.customer.marriedStatus = 'S'
											}
										}
									} else if (type == 2) {
										vm.proposal.laList[0].customer.age = result.age;
										if (result.age > 120) {
											self
													.addAlert(
															'Tuổi Người Được Bảo Hiểm phải nhỏ hơn 120',
															'danger');
											vm.proposal.laList[0].customer.age = null;
											vm.proposal.laList[0].customer.dob = null;
											vm.flagAgeValidate = true;
										} else {

											vm.loadQuanHe(1);
											// 20180626: On leave: tính tuổi của
											// client --> nếu tuổi ≤ 16 tuổi: hệ
											// thống điền giá trị "Độc thân" vô
											// field <Tình trạng hôn nhân>/"Tình
											// trạng gia đình"
											if (result.age <= 16) {
												vm.proposal.laList[0].customer.marriedStatus = 'S'
											}
											vm.flagAgeValidate = false;
										}

									} else if (type === 3) {
										vm.proposal.laList[1].customer.age = result.age;
										if (result.age > 120) {
											self
													.addAlert(
															'Tuổi Người Được Bảo Hiểm phải nhỏ hơn 120',
															'danger');
											vm.proposal.laList[1].customer.age = null;
											vm.proposal.laList[1].customer.dob = null;
											vm.flagAgeValidate = true;
										} else {
											vm.flagAgeValidate = false;
											vm.loadQuanHe(2);
											// 20180626: On leave: tính tuổi của
											// client --> nếu tuổi ≤ 16 tuổi: hệ
											// thống điền giá trị "Độc thân" vô
											// field <Tình trạng hôn nhân>/"Tình
											// trạng gia đình"
											if (result.age <= 16) {
												vm.proposal.laList[1].customer.marriedStatus = 'S'
											}
										}

									} else if (type == 4) {
										vm.proposal.laList[2].customer.age = result.age;
										if (result.age > 120) {
											self
													.addAlert(
															'Tuổi Người Được Bảo Hiểm phải nhỏ hơn 120',
															'danger');
											vm.proposal.laList[2].customer.age = null;
											vm.proposal.laList[2].customer.dob = null;
											vm.flagAgeValidate = true;
										} else {
											vm.flagAgeValidate = false;
											vm.loadQuanHe(3);
											// 20180626: On leave: tính tuổi của
											// client --> nếu tuổi ≤ 16 tuổi: hệ
											// thống điền giá trị "Độc thân" vô
											// field <Tình trạng hôn nhân>/"Tình
											// trạng gia đình"
											if (result.age <= 16) {
												vm.proposal.laList[2].customer.marriedStatus = 'S'
											}
										}

									} else if (type === 5) {
										vm.proposal.laList[3].customer.age = result.age;
										if (result.age > 120) {
											self
													.addAlert(
															'Tuổi Người Được Bảo Hiểm phải nhỏ hơn 120',
															'danger');
											vm.proposal.laList[3].customer.age = null;
											vm.proposal.laList[3].customer.dob = null;
											vm.flagAgeValidate = true;
										} else {
											vm.flagAgeValidate = false;
											vm.loadQuanHe(4);
											// 20180626: On leave: tính tuổi của
											// client --> nếu tuổi ≤ 16 tuổi: hệ
											// thống điền giá trị "Độc thân" vô
											// field <Tình trạng hôn nhân>/"Tình
											// trạng gia đình"
											if (result.age <= 16) {
												vm.proposal.laList[3].customer.marriedStatus = 'S'
											}
										}
									}
								}
							}).$promise
					.then(function(result) {
						if (type == 2) {
							FileTemplateService
									.get(
											{
												uri : 'validateEntryAge',
												birthMsDate : dob
											},
											function(result) {
												if (result !== null) {
													if (vm.proposal.contractType == 'VL5'
															|| vm.proposal.contractType == 'VL3') {
														if (result.age < 30) {
															self
																	.addAlert(
																			'Người được bảo hiểm chưa đủ tuổi tham gia sản phẩm.',
																			'danger');
															vm.proposal.laList[0].customer.dob = null;
															vm.proposal.laList[0].customer.age = null;
														} else {
															// $scope.clearMessage();
														}
													} else {
														if (result.age <= 16) {
															vm.proposal.laList[0].customer.marriedStatus = 'S'
														}
														// $scope.clearMessage();
													}
												} else {
													// $scope.clearMessage();
												}
											})
						}
					});
		};

		var modalInstance = null;
		vm.checkIDNum = [ -1, -1, -1 ];
		vm.checkIDNumPage5 = [ -1, -1 ];
		vm.checkNameAgeSexNum = [ -1, -1, -1 ];
		vm.checkNameAgeSexPage5 = [ -1, -1 ];
		vm.typeCustomer = null;

		vm.checkCMND = function(cmnd, type) {
			if (cmnd == undefined || cmnd === null || cmnd == '') {
				return;
			}
			// 0: po, 1: la
			vm.typeCustomer = type;
			if (type == 3 || type == 4) {
				if (type == 3)
					vm.checkIDNumPage5[0] = type;
				else if (type == 4)
					vm.checkIDNumPage5[1] = type;
			} else if (type == 0 || type == 1 || type == 2) {
				vm.checkIDNum[type] = type;
			}
			var customerType = '';
			if (vm.typeCustomer != 0) {
				customerType = 'P';
			} else if (vm.typeCustomer == 0) {
				customerType = vm.proposal.po.poType;
			}
			FileTemplateService
					.query(
							{
								uri : 'getListCustomerWithIDNum',
								idNum : cmnd,
								customerType : customerType
							},
							function(result) {
								vm.items = result;
								modalInstance = $uibModal
										.open({
											animation : true,
											templateUrl : GLOBAL_URL
													+ 'partial?uri=ga/newbusiness/filetemplate/modalCMND',
											controller : 'CheckIDNumDialogController',
											controllerAs : 'checkCtrl',
											size : 'lg',
											resolve : {
												items : function() {
													return vm.items;
												}
											}
										});
								modalInstance.result.then(function(clientCode) {
									vm.loadCustomerInfo(clientCode);
									modalInstance = null;
								}, function() {
								});
							});
		};

		vm.loadCustomerInfo = function(clientCode) {
			var customerType = '';
			if (vm.typeCustomer != 0) {
				customerType = 'P';
			} else if (vm.typeCustomer == 0) {
				customerType = vm.proposal.po.poType;
			}
			FileTemplateService.get({
				uri : 'getCustomerInfo',
				clientCode : clientCode,
				customerType : customerType
			}, function(result) {
				if (vm.typeCustomer === 0) {
					setPOInfo(vm, result);
				} else if (vm.typeCustomer === 1) {
					setMainLAInfo(vm, result);
				} else if (vm.typeCustomer === 2) {
					setSubLAInfo(vm, result);
				} else if (vm.typeCustomer === 3) {
					setThirdLAInfo(vm, result);
				} else if (vm.typeCustomer === 4) {
					setFourthLAInfo(vm, result);
				}
			});

		};

		vm.getDistrict = function(provinceCode, type) {
			/*
			 * if (provinceCode !== undefined && provinceCode !== null &&
			 * provinceCode !== '')
			 */{
				if (provinceCode === undefined || provinceCode === null) {
					provinceCode = '';
				}
				FileTemplateService
						.query(
								{
									uri : 'getDistrictList',
									provinceCode : provinceCode
								},
								function(result) {
									if (result != null) {
										if (type == 1) {
											if (vm.validateForm.provinceAddressPO !== undefined
													&& vm.validateForm.provinceForeignAddressPO !== null
													&& vm.validateForm.provinceForeignAddressPO.$dirty) {
												vm.districtForeignAddressPO = null;
												vm.proposal.po.customer.locationCode = null;
											}
											vm.listDistrictForeign = result
										} else if (type == 2) {
											if (vm.validateForm.provinceAddressPO !== undefined
													&& vm.validateForm.provinceForeignAddressPO !== null
													&& vm.validateForm.provinceForeignAddressPO.$dirty) {
												vm.districtForeignAddressPO = null;
												vm.proposal.po.customer.locationCode = null;
											}
											vm.listDistrictForeignPersonal = result;
										} else if (type == 3) {
											if (vm.validateForm.provinceAddressPO !== undefined
													&& vm.validateForm.provinceAddressPO !== null
													&& vm.validateForm.provinceAddressPO.$dirty) {
												vm.proposal.alternativeAddress.districtCode = null;
												vm.proposal.alternativeAddress.wardCode = null;
											}
											vm.listDistrictVN = result;
										} else if (type == 4) {
											if (vm.validateForm.provinceMainLA !== undefined
													&& vm.validateForm.provinceMainLA !== null
													&& vm.validateForm.provinceMainLA.$dirty) {
												vm.districtMainLA = null;
												vm.proposal.laList[0].customer.locationCode = null;
											}
											vm.listDistrictMainLA = result;
										} else if (type == 5) {
											if (vm.validateForm.provincesubLA !== undefined
													&& vm.validateForm.provincesubLA !== null
													&& vm.validateForm.provincesubLA.$dirty) {
												vm.districtsubLA = null;
												vm.proposal.laList[1].customer.locationCode = null;
											}
											vm.listDistrictSubLA = result;
										} else if (type == 6) {
											if (vm.validateForm.provincethirdLA !== undefined
													&& vm.validateForm.provincethirdLA !== null
													&& vm.validateForm.provincethirdLA.$dirty) {
												vm.districtthirdLA = null;
												vm.proposal.laList[2].customer.locationCode = null;
											}
											vm.listDistrictthirdLA = result;
										} else if (type == 7) {
											if (vm.validateForm.provincefourthLA !== undefined
													&& vm.validateForm.provincefourthLA !== null
													&& vm.validateForm.provincefourthLA.$dirty) {
												vm.districtfourthLA = null;
												vm.proposal.laList[3].customer.locationCode = null;
											}
											vm.listDistrictfourthLA = result;
										} else if (type == 8) {
											if (vm.validateForm.provinceCodeFAO !== undefined
													&& vm.validateForm.provinceCodeFAO !== null
													&& vm.validateForm.provinceCodeFAO.$dirty) {
												vm.districtCodeFAO = null;
												vm.proposal.po.customer.faoAddress.districtCode = null;
											}
											vm.listDistrictFAO = result;
										}
										//
										vm.listDistrictMainLA = result;
										vm.listDistrictSubLA = result;
										vm.listDistrictthirdLA = result;
										vm.listDistrictfourthLA = result;

										vm.copyProvinceLA(provinceCode);
									}
								});
			}
		};

		vm.getWard = function(districtCode, type) {
			/*
			 * if (districtCode === undefined || districtCode === null ||
			 * districtCode === '') return;
			 */
			if (districtCode === undefined || districtCode === null) {
				districtCode = '';
			}
			FileTemplateService
					.query(
							{
								uri : 'getWardList',
								districtCode : districtCode
							},
							function(result) {
								if (result != null) {
									if (type == 1) {
										if (vm.validateForm.districtForeignAddressPO !== undefined
												&& vm.validateForm.districtForeignAddressPO !== null
												&& vm.validateForm.districtForeignAddressPO.$dirty) {
											vm.proposal.po.customer.locationCode = null;
										}
										vm.listWardForeign = result;
									} else if (type == 2) {
										if (vm.validateForm.districtForeignAddressPO !== undefined
												&& vm.validateForm.districtForeignAddressPO !== null
												&& vm.validateForm.districtForeignAddressPO.$dirty) {
											vm.proposal.po.customer.locationCode = null;
										}
										vm.listWardForeignPersonal = result;
									} else if (type == 3) {
										if (vm.validateForm.districtAddressPO !== undefined
												&& vm.validateForm.districtAddressPO !== null
												&& vm.validateForm.districtAddressPO.$dirty) {
											vm.proposal.alternativeAddress.wardCode = null;
										}
										vm.listWardVN = result;
									} else if (type == 4) {
										if (vm.validateForm.districtMainLA !== undefined
												&& vm.validateForm.districtMainLA !== null
												&& vm.validateForm.districtMainLA.$dirty) {
											vm.proposal.laList[0].customer.locationCode = null;
										}
										vm.listWardMainLA = result;
									} else if (type == 5) {
										if (vm.validateForm.districtsubLA !== undefined
												&& vm.validateForm.districtsubLA !== null
												&& vm.validateForm.districtsubLA.$dirty) {
											vm.proposal.laList[1].customer.locationCode = null;
										}
										vm.listWardSubLA = result;
									} else if (type == 6) {
										if (vm.validateForm.districtthirdLA !== undefined
												&& vm.validateForm.districtthirdLA !== null
												&& vm.validateForm.districtthirdLA.$dirty) {
											vm.proposal.laList[2].customer.locationCode = null;
										}
										vm.listWardthirdLA = result;
									} else if (type == 7) {
										if (vm.validateForm.districtfourthLA !== undefined
												&& vm.validateForm.districtfourthLA !== null
												&& vm.validateForm.districtfourthLA.$dirty) {
											vm.proposal.laList[3].customer.locationCode = null;
										}
										vm.listWardfourthLA = result;
									} else if (type == 8) {
										if (vm.validateForm.districtCodeFAO !== undefined
												&& vm.validateForm.districtCodeFAO !== null
												&& vm.validateForm.districtCodeFAO.$dirty) {
											vm.proposal.po.customer.faoAddress.wardCode = null;
										}
										vm.listWardFAO = result;
									}
									vm.listWardMainLA = result;
									vm.listWardSubLA = result;
									vm.listWardthirdLA = result;
									vm.listWardfourthLA = result;
									vm.copyDistrictLA(districtCode);
								}
							});
		};

		vm.checkPOIsLA = function(isPOLA) {
			vm.proposal.isPoLa = isPOLA;
			if (isPOLA === 1) {
				if (!vm.PoIsLA) {
					vm.provinceMainLA = null;
					vm.districtMainLA = null;
					vm.proposal.laList[0].relationshipCode = '';
					angular.copy(vm.initCustomer(),
							vm.proposal.laList[0].customer);
					vm.relationShipLAMain = [];
				} else {
					vm.PoIsBHBS = false;
					angular.copy(vm.proposal.po.customer,
							vm.proposal.laList[0].customer);
					if (vm.proposal.laList[0].customer.locationCode !== null
							&& vm.proposal.laList[0].customer.locationCode.length >= 6) {
						var locationCode = vm.proposal.laList[0].customer.locationCode;
						var province = locationCode.substring(0, 2);
						vm.provinceMainLA = province;
						vm.getDistrict(province, 4);
						var district = locationCode.substring(0, 4);
						vm.districtMainLA = district;
						vm.getWard(district, 4);
					}
					if(vm.proposal.po.customer.otherNationality !== null
					 	&& vm.proposal.po.addressOther !== null)
					{
						vm.proposal.laList[0].customer.foreignAddress = vm.proposal.po.addressOther;
					}

					vm.proposal.laList[0].relationshipCode = '0000';
					if (checked == 2) {
						vm.provincesubLA = null;
						vm.districtsubLA = null;
						vm.proposal.laList[1].relationshipCode = '';
						vm.relationShipLASub1 = [];
						angular.copy(vm.initCustomer(),
								vm.proposal.laList[1].customer);
						checked = 1;
					} else if (checked == 0) {
						checked = 1;
					}
					vm.loadQuanHe(isPOLA);
				}
			} else if (isPOLA === 2) {
				if (!vm.PoIsBHBS) {
					angular.copy(vm.initCustomer(),
							vm.proposal.laList[1].customer);
					vm.provincesubLA = null;
					vm.districtsubLA = null;
					vm.proposal.laList[1].relationshipCode = '';
					vm.relationShipLASub1 = [];
				} else {
					vm.PoIsLA = false;
					angular.copy(vm.proposal.po.customer,
							vm.proposal.laList[1].customer);
					if (vm.proposal.laList[1].customer.locationCode !== null
							&& vm.proposal.laList[1].customer.locationCode.length >= 6) {
						var locationCode = vm.proposal.laList[1].customer.locationCode;
						var province = locationCode.substring(0, 2);
						vm.provincesubLA = province;
						vm.getDistrict(province, 5);
						var district = locationCode.substring(0, 4);
						vm.districtsubLA = district;
						vm.getWard(district, 5);
					}
					if(vm.proposal.po.customer.otherNationality !== null
						&& vm.proposal.po.addressOther !== null)
					{
						vm.proposal.laList[1].customer.foreignAddress = vm.proposal.po.addressOther;
					}
					vm.proposal.laList[1].relationshipCode = '0000';
					if (checked == 1) {
						vm.provinceMainLA = null;
						vm.districtMainLA = null;
						vm.proposal.laList[0].relationshipCode = '';
						vm.relationShipLAMain = [];
						angular.copy(vm.initCustomer(),
								vm.proposal.laList[0].customer);
						checked = 2;
					} else if (checked == 0) {
						checked = 2;
					}
					vm.loadQuanHe(isPOLA);
				}
			}
		}

		$timeout(function() {
			angular.element('#login').focus();
		});

		vm.createTemplateFile = function() {
			if (vm.flgCheckIdNumLA == true) {
				$scope.clearMessage();
				self.addAlert('Các LA bị trùng số ID.', 'danger');
				return;
			}
			// set Rider
			if (vm.index == 7) {
				if (!vm.sioCampaign) {
					if (vm.validatePage7()) {
						$(window).scrollTop(0);
						return false;
					}
				}

			}

			if (vm.index == 4) {
				if (vm.validatePage4()) {
					$(window).scrollTop(0);
					return false;
				}
			}
			if (vm.index == 9) {
				if (vm.validatePage9()) {
					$(window).scrollTop(0);
					return false;
				}
			}
			if (vm.index == 1) {
				$scope.clearMessage();
				var flag = vm.invalidTab1();
				if (flag || vm.flgCheckIdNumLA) {
					$(window).scrollTop(0);
					if (vm.flgCheckIdNumLA) {
						$scope.clearMessage();
						self.addAlert('Các LA bị trùng số ID.', 'danger');
					}
					return;
				}
			}

			if (vm.index == 2) {
				if (vm.validatePage2()) {
					$(window).scrollTop(0);
					return false;
				}
			}
			vm.setQuestion8();
			vm.proposal.sioCampaign = vm.sioCampaign;
			if (vm.proposal.sioCampaign) {
				var numLa = 0;
				for (var i = 0; i < vm.proposal.laList.length; i++) {
					if (vm.proposal.laList[i].customer.idNum != null
							&& vm.proposal.laList[i].customer.idNum != undefined
							&& vm.proposal.laList[i].customer.idNum != '') {
						numLa++;
					}
				}
				if (numLa > 1) {
					$scope.clearMessage();
					self
							.addAlert(
									'Hồ sơ SIO không được có nhiều người được bảo hiểm. Vui lòng kiểm tra lại',
									'danger');
					return;
				}
			}
			if(vm.proposal.lisththtDirectLead != undefined && vm.proposal.lisththtDirectLead != null){
				vm.proposal.hthtDirectLead = vm.proposal.lisththtDirectLead.toString();
			}
			if(vm.proposal.lisththtInDirectLead != undefined && vm.proposal.lisththtInDirectLead != null){
				vm.proposal.hthtInDirectLead = vm.proposal.lisththtInDirectLead.toString();
			}

			if(vm.provinceCodeFAO != undefined && vm.provinceCodeFAO != null)
			{
				vm.proposal.po.customer.faoAddress.provinceCode = vm.provinceCodeFAO;
			}

			if(vm.districtCodeFAO != undefined && vm.districtCodeFAO != null)
			{
				vm.proposal.po.customer.faoAddress.districtCode = vm.districtCodeFAO;
			}

			if (vm.proposal.po.incomeRange != '05') {
				vm.proposal.po.incomeDetail = vm.proposal.po.customer.incomeDetail;
			}

			var data = [];

			data['proposal'] = new Blob([ JSON.stringify(vm.proposal) ], {
				type : "application/json"
			});
			$scope.loading = true;
			// mutiple images
			if (vm.filesByPaperType !== undefined
					&& vm.filesByPaperType !== null
					&& vm.filesByPaperType.length > 0) {
				var files = [];
				var paperTypeCodes = [];
				for (var int = 0; int < vm.filesByPaperType.length; int++) {
					if (vm.filesByPaperType[int].archiveDataId != null
							&& vm.filesByPaperType[int].archiveDataId != undefined
							&& vm.filesByPaperType[int].archiveDataId == 0) {
						files.push(vm.filesByPaperType[int].file);
						paperTypeCodes
								.push({
									'paperType' : vm.filesByPaperType[int].paperType,
									'paperTypeName' : vm.filesByPaperType[int].paperTypeName
								});
					}
				}
				data['file'] = files;
				data['filesByPaperType'] = new Blob([ JSON
						.stringify(paperTypeCodes) ], {
					type : "application/json"
				});
				Upload
						.upload(
								{
									url : GLOBAL_URL
											+ 'api/request/saveInsuranceApplication?access_token='
											+ authExpiredInterceptor.getToken(),
									data : data,
									arrayKey : ''
								})
						.then(
								function(result) {
									$(window).scrollTop(0);
									if (result
											&& result.data != null
											&& result.data.insuranceApplicationId != null
											&& result.data.insuranceApplicationId != undefined) {
										FileTemplateService
												.query(
														{
															uri : 'get-list-archive-data',
															insuranceApplicationId : result.data.insuranceApplicationId
														},
														function(respon) {
															if (respon) {
																vm.filesByPaperType = [];
																for (var int = 0; int < respon.length; int++) {
																	var file = {};
																	file.name = respon[int].dataName;
																	file.size = respon[int].contentType;
																	file.type = respon[int].dataType;
																	file.archiveDataId = respon[int].archiveDataId;
																	if (respon[int].paperType != null
																			&& respon[int].paperType != undefined) {
																		var obj = {
																			'file' : file,
																			'paperType' : respon[int].paperType,
																			'paperTypeName' : getNameDropDownList(respon[int].paperType),
																			'archiveDataId' : respon[int].archiveDataId
																		};
																		vm.filesByPaperType
																				.push(obj);
																	} else {
																		var obj = {
																			'file' : file,
																			'paperType' : respon[int].paperType,
																			'paperTypeName' : getNameDropDownList(respon[int].paperType),
																			'archiveDataId' : respon[int].archiveDataId
																		};
																		vm.filesByPaperType
																				.push(obj);
																		break;
																	}

																}
															}
															$scope.loading = false;
														},
														function() {
															$scope.loading = false;
														});
									}
									// vm.proposal.dataName =
									// vm.attachment.name;
								}, function(result) {
									$scope.loading = false;
								}, function(evt) {
									$scope.loading = false;
								});
			} else {
				FileTemplateService.post({
					uri : 'saveInsurance'
				}, vm.proposal, function() {
					$(window).scrollTop(0);
					$scope.loading = false;
				}, function() {
					$scope.loading = false;
				});
			}

		}

		vm.sendnb = function() {
			// check validate all page
			if (vm.validatePage2Send() || vm.validatePage3()
					|| vm.validatePage4()) {
				return false;
			}
			if (!vm.sioCampaign) {
				if (vm.validatePage7()) {
					return false;
				}
			}
			vm.setQuestion8();
			vm.proposal.sioCampaign = vm.sioCampaign;
			if (vm.proposal.sioCampaign) {
				var numLa = 0;
				for (var i = 0; i < vm.proposal.laList.length; i++) {
					if (vm.proposal.laList[i].customer.idNum != null
							&& vm.proposal.laList[i].customer.idNum != undefined
							&& vm.proposal.laList[i].customer.idNum != '') {
						numLa++;
					}
				}
				if (numLa > 1) {
					$scope.clearMessage();
					self
							.addAlert(
									'Hồ sơ SIO không được có nhiều người được bảo hiểm. Vui lòng kiểm tra lại',
									'danger');
					return;
				}
			}
			var data = [];
			// mutiple images
			if (vm.filesByPaperType !== undefined
					&& vm.filesByPaperType !== null) {
				var files = [];
				var paperTypeCodes = [];
				for (var int = 0; int < vm.filesByPaperType.length; int++) {
					if (vm.filesByPaperType[int].archiveDataId != null
							&& vm.filesByPaperType[int].archiveDataId != undefined
							&& vm.filesByPaperType[int].archiveDataId == 0) {
						files.push(vm.filesByPaperType[int].file);
						paperTypeCodes
								.push({
									'paperType' : vm.filesByPaperType[int].paperType,
									'paperTypeName' : vm.filesByPaperType[int].paperTypeName
								});
					}
				}
				data['file'] = files;
				data['filesByPaperType'] = new Blob([ JSON
						.stringify(paperTypeCodes) ], {
					type : "application/json"
				});
			}
			if (vm.attachmentLiberty !== undefined
					&& vm.attachmentLiberty !== null) {
				data['fileLiberty'] = vm.attachmentLiberty;
				/*
				 * } else { data['file'] = new File([ "" ], "filename.txt");
				 */
			}

			if (vm.proposal.po.incomeRange != '05') {
				vm.proposal.po.incomeDetail = vm.proposal.po.customer.incomeDetail;
			}

			data['proposal'] = new Blob([ JSON.stringify(vm.proposal) ], {
				type : "application/json"
			});
			$scope.loading = true;
			Upload.upload(
					{
						url : GLOBAL_URL + 'api/request/sendnb?access_token='
								+ authExpiredInterceptor.getToken(),
						data : data,
						arrayKey : ''
					}).then(function(result) {
				$scope.loading = false;
				$(window).scrollTop(0);
				if (result.data.messages[0].type === 'success') {
					vm.proposal.checkAllDisable = true;
					vm.isResultError=false;
				}else{
					vm.isResultError=true;
				}
			}, function(result) {
				$scope.loading = false;
			}, function(evt) {
				// $scope.loading = false;
			});
		}
		// vm.sendLiberty = function() {
		// var data = [];
		// if (vm.attachment !== undefined && vm.attachment !== null) {
		// data['file'] = vm.attachment;
		// /*
		// * } else { data['file'] = new File([ "" ], "filename.txt");
		// */
		// }
		// data['proposal'] = new Blob([ JSON.stringify(vm.proposal) ], {
		// type : "application/json"
		// });
		// $scope.loading = true;
		// Upload.upload(
		// {
		// url : GLOBAL_URL + 'api/request/sendLiberty?access_token='
		// + authExpiredInterceptor.getToken(),
		// data : data
		// }).then(function(result) {
		// $scope.loading = false;
		// if (result.status === 200) {
		// vm.proposal.checkAllDisable = true;
		// }
		// }, function(result) {
		// $scope.loading = false;
		// }, function(evt) {
		// // $scope.loading = false;
		// });
		// }

		// vm.relationShipPO = [];
		vm.relationShipLAMain = [];
		vm.relationShipLASub1 = [];
		vm.relationShipLASub2 = [];
		vm.relationShipLASub3 = [];

		vm.loadQuanHe = function(type) {
			if (vm.proposal.po.poType == 'C')
				return;
			if (vm.proposal.po.customer.dob != undefined
					&& vm.proposal.po.customer.dob != null
					&& vm.proposal.po.customer.dob != '') {
				var dateNow = new Date();
				if (vm.proposal.po.customer.dob > dateNow.getTime()) {
					return;
				}
				// var birth = new Date(vm.proposal.po.customer.dob);
				var birth = null;
				if (type == 1) {
					if (vm.proposal.laList[0].customer.dob === undefined
							|| vm.proposal.laList[0].customer.dob === null
							|| vm.proposal.laList[0].customer.dob == '')
						return;
					// vm.proposal.laList[0].relationshipCode = '';
					birth = new Date(vm.proposal.laList[0].customer.dob);
				} else if (type == 2) {
					if (vm.proposal.laList[1].customer.dob === undefined
							|| vm.proposal.laList[1].customer.dob === null
							|| vm.proposal.laList[1].customer.dob == '')
						return;
					// vm.proposal.laList[1].relationshipCode = '';
					birth = new Date(vm.proposal.laList[1].customer.dob);
				} else if (type == 3) {
					if (vm.proposal.laList[2].customer.dob === undefined
							|| vm.proposal.laList[2].customer.dob === null
							|| vm.proposal.laList[2].customer.dob == '')
						return;
					// vm.proposal.laList[2].relationshipCode = '';
					birth = new Date(vm.proposal.laList[2].customer.dob);
				} else if (type == 4) {
					if (vm.proposal.laList[3].customer.dob === undefined
							|| vm.proposal.laList[3].customer.dob === null
							|| vm.proposal.laList[3].customer.dob == '')
						return;
					// vm.proposal.laList[3].relationshipCode = '';
					birth = new Date(vm.proposal.laList[3].customer.dob);
				}
				FileTemplateService.query({
					uri : 'getRelationShip',
					birth : birth,
					gender : vm.proposal.po.customer.gender
				}, function(result) {
					if (type == 1) {
						vm.relationShipLAMain = result;
					} else if (type == 2) {
						vm.relationShipLASub1 = result;
					} else if (type == 3) {
						vm.relationShipLASub2 = result;
					} else if (type == 4) {
						vm.relationShipLASub3 = result;
					}
				})
			}
		};

		vm.changeRelationShip = function() {
			if (vm.proposal.po.poType == 'C') {
				if (vm.PoIsLA) {
					vm.PoIsLA = false;
					vm.checkPOIsLA(1);
				}
				if (vm.PoIsBHBS) {
					vm.PoIsBHBS = false;
					vm.checkPOIsLA(2);
				}
				vm.checkIDNum[0] = -1;
				vm.relationShipLAMain = [ {
					code : '0000',
					name : 'Nhân viên'
				} ];
				vm.relationShipLASub1 = [ {
					code : '0000',
					name : 'Nhân viên'
				} ];
				vm.relationShipLASub2 = [ {
					code : '0000',
					name : 'Nhân viên'
				} ];
				vm.relationShipLASub3 = [ {
					code : '0000',
					name : 'Nhân viên'
				} ];

				if (vm.provinceForeignAddressPO !== undefined
						&& vm.provinceForeignAddressPO !== null
						&& vm.provinceForeignAddressPO !== '') {
					vm.getDistrict(vm.provinceForeignAddressPO, 1);
				}
				if (vm.districtForeignAddressPO !== undefined
						&& vm.districtForeignAddressPO !== null
						&& vm.districtForeignAddressPO !== '') {
					vm.getWard(vm.districtForeignAddressPO, 1);
				}
			} else if (vm.proposal.po.poType == 'P') {
				vm.loadQuanHe(1);
				vm.loadQuanHe(2);
				vm.loadQuanHe(3);
				vm.loadQuanHe(4);
				vm.checkIDNum[0] = -1;
				if (vm.provinceForeignAddressPO !== undefined
						&& vm.provinceForeignAddressPO !== null
						&& vm.provinceForeignAddressPO !== '') {
					vm.getDistrict(vm.provinceForeignAddressPO, 2);
				}
				if (vm.districtForeignAddressPO !== undefined
						&& vm.districtForeignAddressPO !== null
						&& vm.districtForeignAddressPO !== '') {
					vm.getWard(vm.districtForeignAddressPO, 2);
				}
			}
		}

		vm.searchQuotation = function() {
			$scope.clearMessage();
			if (vm.proposal.quotationID === null
					|| vm.proposal.quotationID == '') {
				$scope.clearMessage();
				self.addAlert('Chưa nhập minh họa số.', 'danger');
				return;
			}
			if (vm.proposal.agentCode === null || vm.proposal.agentCode == '') {
				$scope.clearMessage();
				self.addAlert('Chưa nhập số tư vấn viên.', 'danger');
				return;
			}
			vm.PoIsLA = false;
			vm.PoIsBHBS = false;
			FileTemplateService
					.get(
							{
								uri : 'searchQuotation',
								quotationID : vm.proposal.quotationID,
								agentCode : vm.proposal.agentCode,
								proposalNum : vm.proposal.proposalNum,
								sharedAgentCode : vm.proposal.sharedAgentCode
							},
							function(result) {
								if (result != null && result.po != undefined
										&& result.po != null) {
									if ("TL1" === result.contractType || "TL2" === result.contractType || "TL4" === result.contractType ||
											"TL5" === result.contractType || "TL8" === result.contractType || "MI1" === result.contractType) {
										self.addAlert('Sản phẩm ' + result.contractType + ' đã ngừng bán.','error');
										return;
									}
									
									if (result.sioPruquotRider
											&& vm.sioCampaign) {
										self
												.addAlert(
														'Pruquote không phù hợp cho hồ sơ SIO do có sản phẩm bổ trợ đính kèm.',
														'warning');
									} else {
										vm.proposal = result;
										if (vm.proposal.agentCode !== null) {
											vm.searchAgent(1);
										} else {
											vm.agentName = null;
										}
										if (vm.proposal.sharedAgentCode !== null) {
											vm.searchAgent(2);
										} else {
											vm.sharedAgentName = null;
										}

						if (vm.proposal.contractType === 'VL5') {
							vm.maxlength = 3;
						}
						// if (vm.proposal.contractType.includes("VL")) {
						if (vm.proposal.contractType.indexOf("VL") !== -1) {
							vm.showExcess = true;
						}
						if (vm.proposal.isPoLa == '2') {
							vm.PoIsBHBS = true;
							angular.copy(vm.proposal.po.customer,
									vm.proposal.laList[1].customer);
						} else if (vm.proposal.isPoLa == '1') {
							vm.PoIsLA = true;
							angular.copy(vm.proposal.po.customer,
									vm.proposal.laList[0].customer);
						}
						vm.calculaNumberYear(vm.proposal.receiptDate,
								vm.proposal.po.customer.dob, 1);
						vm.calculaNumberYear(1, vm.proposal.laList[0].customer.dob,
								2);
						vm.calculaNumberYear(1, vm.proposal.laList[1].customer.dob,
								3);
						vm.calculaNumberYear(1, vm.proposal.laList[2].customer.dob,
								4);
						vm.calculaNumberYear(1, vm.proposal.laList[3].customer.dob,
								5);
						initPage1(vm, self);
						initPage2(vm, FileTemplateService, self);
						initPage3(vm);
						initPage4(vm, FileTemplateService, self);
						initPage6(vm);
						initPage7(vm, FileTemplateService, self);
						initPage8(vm);
						//vm.getRiderQuotation();
					}
					/*if (vm.proposal.sharedAgentCode !== null) {
						vm.searchAgent(2);
					} else {
						vm.sharedAgentName = null;
					}

					if (vm.proposal.contractType === 'VL5') {
						vm.maxlength = 3;
					}
					// if (vm.proposal.contractType.includes("VL")) {
					if (vm.proposal.contractType.indexOf("VL") !== -1) {
						vm.showExcess = true;
					}
					if (vm.proposal.isPoLa == '2') {
						vm.PoIsBHBS = true;
						angular.copy(vm.proposal.po.customer,
								vm.proposal.laList[1].customer);
					} else if (vm.proposal.isPoLa == '1') {
						vm.PoIsLA = true;
						angular.copy(vm.proposal.po.customer,
								vm.proposal.laList[0].customer);
					}
					vm.calculaNumberYear(vm.proposal.receiptDate,
							vm.proposal.po.customer.dob, 1);
					vm.calculaNumberYear(1, vm.proposal.laList[0].customer.dob,
							2);
					vm.calculaNumberYear(1, vm.proposal.laList[1].customer.dob,
							3);
					vm.calculaNumberYear(1, vm.proposal.laList[2].customer.dob,
							4);
					vm.calculaNumberYear(1, vm.proposal.laList[3].customer.dob,
							5);
					initPage1(vm, self);
					initPage2(vm, FileTemplateService, self);
					initPage3(vm);
					initPage4(vm, FileTemplateService, self);
					initPage6(vm);
					initPage7(vm, FileTemplateService, self);
					initPage8(vm);
					vm.getRiderQuotation();*/
				} else {
					$scope.clearMessage();
					self.addAlert('Minh họa số không hỗ trợ sản phẩm này.',
							'danger');
				}
			});
		}

		vm.checkAlternativeAddress = function() {
			if (vm.proposal.alternativeAddress.provinceCode != undefined
					&& vm.proposal.alternativeAddress.provinceCode != null
					&& vm.proposal.alternativeAddress.provinceCode.length >= 2) {
				vm.getDistrict(vm.proposal.alternativeAddress.provinceCode, 3);
			}
			vm.proposal.alternativeAddress.districtCode = vm.districtForeignAddressPO;
			if (vm.proposal.alternativeAddress.districtCode != undefined
					&& vm.proposal.alternativeAddress.districtCode != null
					&& vm.proposal.alternativeAddress.districtCode.length >= 4) {
				vm.getWard(vm.proposal.alternativeAddress.districtCode, 3);
			}
			/*
			 * if (vm.checkAlternaitve) { vm.proposal.alternativeAddress.street =
			 * vm.proposal.po.customer.street;
			 * vm.proposal.alternativeAddress.countryCode =
			 * vm.proposal.po.customer.residentCountryCode;
			 * vm.proposal.alternativeAddress.provinceCode =
			 * vm.provinceForeignAddressPO;
			 * 
			 * vm.proposal.alternativeAddress.wardCode =
			 * vm.proposal.po.customer.locationCode; } else {
			 * vm.proposal.alternativeAddress.street = "";
			 * vm.proposal.alternativeAddress.countryCode = "";
			 * vm.proposal.alternativeAddress.provinceCode = "";
			 * vm.proposal.alternativeAddress.districtCode = "";
			 * vm.proposal.alternativeAddress.wardCode = ""; }
			 */
		}

		vm.changeWard = function() {
			/*
			 * if (vm.PoIsLA) { if (vm.proposal.laList[0].customer.locationCode
			 * !== null && vm.proposal.laList[0].customer.locationCode.length >=
			 * 6) { var locationCode =
			 * vm.proposal.laList[0].customer.locationCode; var province =
			 * locationCode.substring(0, 2); vm.provinceMainLA = province;
			 * vm.getDistrict(province, 4); var district =
			 * locationCode.substring(0, 4); vm.districtMainLA = district;
			 * vm.getWard(district, 4); } if
			 * (vm.proposal.po.customer.locationCode !== null &&
			 * vm.proposal.po.customer.locationCode.length >= 6) { var
			 * locationCode = vm.proposal.po.customer.locationCode; var province =
			 * locationCode.substring(0, 2); vm.provinceForeignAddressPO =
			 * province; vm.getDistrict(province, 2); var district =
			 * locationCode.substring(0, 4); vm.districtForeignAddressPO =
			 * district; vm.getWard(district, 2); } } else if (vm.PoIsBHBS) { if
			 * (vm.proposal.laList[1].customer.locationCode !== null &&
			 * vm.proposal.laList[1].customer.locationCode.length >= 6) { var
			 * locationCode = vm.proposal.laList[1].customer.locationCode; var
			 * province = locationCode.substring(0, 2); vm.provincesubLA =
			 * province; vm.getDistrict(province, 5); var district =
			 * locationCode.substring(0, 4); vm.districtsubLA = district;
			 * vm.getWard(district, 5); } if
			 * (vm.proposal.po.customer.locationCode !== null &&
			 * vm.proposal.po.customer.locationCode.length >= 6) { var
			 * locationCode = vm.proposal.po.customer.locationCode; var province =
			 * locationCode.substring(0, 2); vm.provinceForeignAddressPO =
			 * province; vm.getDistrict(province, 2); var district =
			 * locationCode.substring(0, 4); vm.districtForeignAddressPO =
			 * district; vm.getWard(district, 2); } }
			 */
		}

		vm.validateAllRequired = function(flag) {
			var error = vm.validateForm.$error.required;
			if (error != undefined) {
				for (var i = 0; i < error.length; i++) {
					if (error[i].$invalid) {
						error[i].$setValidity("required", false);
						error[i].$setTouched();
						error[i].$setDirty();
						flag = true;
					}
				}
			}
			var error = vm.validateForm.$error.minlength;
			if (error != undefined) {
				for (var i = 0; i < error.length; i++) {
					if (error[i].$invalid) {
						error[i].$setValidity("minlength", false);
						error[i].$setTouched();
						error[i].$setDirty();
						flag = true;
					}
				}
			}
			var error = vm.validateForm.$error.maxlength;
			if (error != undefined) {
				for (var i = 0; i < error.length; i++) {
					if (error[i].$invalid) {
						error[i].$setValidity("maxlength", false);
						error[i].$setTouched();
						error[i].$setDirty();
						flag = true;
					}
				}
			}
			var error = vm.validateForm.$error.pattern;
			if (error != undefined) {
				for (var i = 0; i < error.length; i++) {
					if (error[i].$invalid) {
						error[i].$setValidity("pattern", false);
						error[i].$setTouched();
						error[i].$setDirty();
						flag = true;
					}
				}
			}
			return flag;
		}

		vm.resetProposal = function() {
			/*
			 * vm.getProposalInfo(); vm.agentName = null; vm.sharedAgentName =
			 * null; vm.validateForm.$setPristine();
			 * vm.validateForm.$setUntouched(); vm.changeTabReset(1); vm.PoIsLA =
			 * false; vm.PoIsBHBS = false; $scope.isDisabled = false;
			 */
			//$window.location.reload();
			vm.proposal.checkAllDisable=false;
			$state.transitionTo($state.current, {}, { 
	   			  reload: true, inherit: false, notify: true
	   			});
		}

		vm.initCustomer = function() {
			var cus = {
				evidenceSource : "ID",
				residentCountryCode : "VN",
				nationality : "VN",
				otherNationality : "",
				birthCountryCode : "VN",
				educationCode : "",
				occupation : "OPIT",
				provinceCode : "",
				districtCode : "",
				homePhoneCode : "84",
				mobileCode : "84",
				bizPhoneCode : "84",
				firstName : null,
				lastName : null,
				preferedName : null,
				gender : null,
				dob : null,
				age : null,
				marriedStatus : null,
				ethnic : null,
				street : null,
				locationCode : null,
				idNum : null,
				mobilePhone : null,
				bizPhone : null,
				homePhone : null,
				occupationCode : null,
				occupationClass : null,
				occupationDescription : null,
				magnumCode : null,
				position : null,
				email : null,
				birthPlace : null,
				incomeDetail : null,
				companyName : null,
				companyAddress : null,
				salutation : "QUÝ"
			}
			return cus;
		};

		vm.changeTabReset = function(index) {
			vm.index = index;
			if (index === 1) {
				$state.go('fileTemplate.pageOne');
			}
		};

		vm.removeFileAttach = function(file, errFiles) {
			if (file != undefined && file != null) {
				vm.proposal.dataName = file.name;
			}
		};

		vm.getRiderQuotation = function() {
			if (vm.proposal.quotationID === undefined
					|| vm.proposal.quotationID === null
					|| vm.proposal.quotationID === '')
				return;
			var contractTypeValue = vm.proposal.contractType;
			var mapRiders = [];
			for (var i = 0; i < vm.proposal.laList.length; i++) {
				if (vm.proposal.laList[i].customer != null
						&& vm.proposal.laList[i].customer.idNum !== undefined
						&& vm.proposal.laList[i].customer.idNum !== null
						&& vm.proposal.laList[i].customer.idNum !== ''
						&& vm.proposal.laList[i].customer.lastName != null
						&& vm.proposal.laList[i].customer.firstName != null
						&& vm.proposal.laList[i].customer.lastName != ''
						&& vm.proposal.laList[i].customer.firstName != '') {
					var map = {
						dob : vm.proposal.laList[i].customer.dob,
						age : vm.proposal.laList[i].customer.age,
						relationshipCode : vm.proposal.laList[i].relationshipCode,
						numLa : i,
						components : vm.proposal.laList[i].riderList
					};
					mapRiders.push(map);
				}
			}
			;
			// load laRiderConfigs
			var parameters = {
				contractType : contractTypeValue,
				mapRiders : mapRiders,
				isPoLa : vm.proposal.isPoLa
			};

			FileTemplateService
					.postList(
							{
								uri : 'searchRiderQuotation',
								quotationID : vm.proposal.quotationID,
								agentCode : vm.proposal.agentCode,
								proposalNum : vm.proposal.proposalNum,
								sharedAgentCode : vm.proposal.sharedAgentCode,
								txnId : vm.proposal.txnId
							},
							parameters,
							function(result) {
								vm.listLaRiderConfig = result;
								if (result != null && result[0] != undefined
										&& result[0] != null) {
									vm.notRider = result[0].notRider;
								} else {
									vm.notRider = false;
								}
								for (var i = 0, size = vm.listLaRiderConfig.length; i < size; i++) {
									var laRiderConfig = vm.listLaRiderConfig[i];
									for (var j = 0, length = laRiderConfig.riderConfigRules.length; j < length; j++) {
										vm
												.checkValidateEntryAge(
														laRiderConfig.riderConfigRules[j],
														laRiderConfig.numLa,
														laRiderConfig.riderConfigRules);
									}
								}
							});
		}

		vm.nationalTravel = [];
		vm.loadNationalTravel = function() {
			FileTemplateService.query({
				uri : 'loadNationalTravel'
			}, function(result) {
				if (result != null) {
					vm.nationalTravel = result;
				}
			});
		};

		vm.benefitItems = [];
		vm.getBenefitItems = function() {
			FileTemplateService.query({
				uri : 'getBenefitItems',
				productCode : vm.proposal.contractType
			}, function(result) {
				if (result != null) {
					vm.benefitItems = result;
				}
			});
		};

		vm.getAttachmentInfo = function() {
			FileTemplateService.get({
				uri : 'getAttachmentInfo',
				proposalInfo : vm.proposal.proposalNum
			}, function(result) {
				if (result !== null) {
					vm.download(result);
				}
			});
		}

		vm.download = function(attach) {
			// danh cho ie
			if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for
				// IE
				// browser
				if (attach.content != undefined) {
					var byteCharacters = atob(attach.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : attach.dataType
					});
					window.navigator.msSaveBlob(blob, attach.dataName);
				} else {
					var blob = new Blob([ attach ], {
						type : attach.dataType
					});
					window.navigator.msSaveBlob(blob, attach.dataName);
				}
			} else {
				// truong hop file da luu duoi database
				if (attach.content != undefined) {
					var byteCharacters = atob(attach.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : attach.dataType
					});
					var url = $window.URL || $window.webkitURL;
						var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = attach.dataName;
					aTag.click();
				} else {
					// truong hop file luu tam tren man hinh
					var blob = new Blob([ vm.attachment ], {
						type : vm.attachment.type
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = vm.attachment.name;
					aTag.click();
				}
			}
		}

		vm.downloadLiberty = function(attach) {
			// danh cho ie
			if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for
				// IE
				// browser
				if (attach.content != undefined) {
					var byteCharacters = atob(attach.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : attach.dataType
					});
					window.navigator.msSaveBlob(blob, attach.dataName);
				} else {
					var blob = new Blob([ attach ], {
						type : attach.dataType
					});
					window.navigator.msSaveBlob(blob, attach.dataName);
				}
			} else {
				// truong hop file da luu duoi database
				if (attach.content != undefined) {
					var byteCharacters = atob(attach.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : attach.type
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = attach.name;
					aTag.click();
				} else {
					// truong hop file luu tam tren man hinh
					var blob = new Blob([ vm.attachmentLiberty ], {
						type : vm.attachmentLiberty.type
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = vm.attachmentLiberty.name;
					aTag.click();
				}
			}
		}

		vm.checkTaxCode = function(taxCode) {
			if (taxCode == undefined || taxCode === null || taxCode == '') {
				return;
			}
			vm.typeCustomer = 0;
			var customerType = 'C';
			FileTemplateService
					.query(
							{
								uri : 'getListCustomerWithTaxCode',
								idNum : taxCode,
								customerType : customerType
							},
							function(result) {
								vm.items = result;
								modalInstance = $uibModal
										.open({
											animation : true,
											templateUrl : GLOBAL_URL
													+ 'partial?uri=ga/newbusiness/filetemplate/modalCMND',
											controller : 'CheckIDNumDialogController',
											controllerAs : 'checkCtrl',
											size : 'lg',
											resolve : {
												items : function() {
													return vm.items;
												}
											}
										});
								modalInstance.result.then(function(clientCode) {
									vm.loadCustomerInfo(clientCode);
									modalInstance = null;
								}, function() {
								});
							});
		};

		vm.searchLongDesc = function(type) {
			if (type == 1) {
				FileTemplateService.get({
					uri : 'search-long-desc',
					descItem : vm.proposal.descItem
				}, function(result) {
					vm.proposal.longDesc = result.name;
				});
			} else if (type == 2) {
				FileTemplateService.get({
					uri : 'search-long-desc',
					descItem : vm.proposal.sharedDescItem
				}, function(result) {
					vm.proposal.sharedLongDesc = result.name;
				});
			}
		}

		vm.checkIDnumLA = function() {
			$scope.clearMessage();
			vm.flgCheckIdNumLA = false;
			var listIdNum = [];
			for (var i = 0; i < vm.proposal.laList.length; ++i) {
				var value = vm.proposal.laList[i].customer.idNum;
				if (value != null && value != undefined && value != '') {
					if (listIdNum.indexOf(value) !== -1) {
						vm.flgCheckIdNumLA = true;
						self.addAlert(' Các LA bị trùng số ID.', 'danger');
						return;
					}
					listIdNum.push(value);
				}

			}
		}

		vm.checkAgeNum = function(lgivname, lsurname, cltdob, cltsex,
				customerType) {
			if (lgivname == undefined || lgivname === null || lgivname == ''
					|| lsurname == undefined || lsurname === null
					|| lsurname == '' || cltdob == undefined || cltdob === null
					|| cltdob == '' || cltsex == undefined || cltsex === null
					|| cltsex == '') {
				return;
			}
			// 0: po, 1: la
			vm.typeCustomer = customerType;
			if (customerType == 3 || customerType == 4) {
				if (customerType == 3)
					vm.checkNameAgeSexPage5[0] = customerType;
				else if (customerType == 4)
					vm.checkNameAgeSexPage5[1] = customerType;
			} else if (customerType == 0 || customerType == 1
					|| customerType == 2) {
				vm.checkNameAgeSexNum[customerType] = customerType;
			}
			var customerType = '';
			if (vm.typeCustomer != 0) {
				customerType = 'P';
			} else if (vm.typeCustomer == 0) {
				customerType = vm.proposal.po.poType;
			}
			var date = new Date(cltdob);
			var cltdobDate = date.getTime();
			vm.param.uri = 'get-lis-cus-by-multiple-key';
			vm.param.clientFirstName = lsurname;
			vm.param.clientBirthDate = cltdobDate;
			vm.param.clientLastName = lgivname;
			vm.param.clientGender = cltsex;
			vm.param.clientType = customerType;
			FileTemplateService.query(vm.param).$promise
					.then(function(result) {
						vm.items = result;
						modalInstance = $uibModal
								.open({
									animation : true,
									templateUrl : GLOBAL_URL
											+ 'partial?uri=ga/newbusiness/filetemplate/modalCMND',
									controller : 'CheckIDNumDialogController',
									controllerAs : 'checkCtrl',
									size : 'lg',
									resolve : {
										items : function() {
											return vm.items;
										}
									}
								});
						modalInstance.result.then(function(clientCode) {
							vm.loadCustomerInfo(clientCode);
							modalInstance = null;
						}, function() {
						});
					});
		};
		
		vm.checkValidateEntryAge = function(riderConfig, numLa) {
			if (riderConfig.checked) {
				// vm.proposal.laList[laRiderConfig.numLa].customer.dob;
				var dob = new Date(vm.proposal.laList[numLa].customer.dob)
						.getTime();
				if (riderConfig.code == 'KID1' 
					|| riderConfig.code == 'KID2' || riderConfig.code == 'KID3'
					|| riderConfig.code == 'KID4' || riderConfig.code == 'KID5'
					|| riderConfig.code == 'KID6' || riderConfig.code == 'KID7'
					|| riderConfig.code == 'KID8' || riderConfig.code == 'KID9'
					|| riderConfig.code == 'CIR4' || riderConfig.code == 'ADD6') {
				FileTemplateService
				.get(
					{
						uri : 'validateEntryAge',
						birthMsDate : dob
					},
					function(result) {
						if (result !== null) {
							if (result.age < 30) {
								self.addAlert( 'Người được bảo hiểm chưa đủ tuổi tham gia sản phẩm.', 'danger');
								riderConfig.checked = false;
							} else {
								$scope.clearMessage();
							}
						} else {
							$scope.clearMessage();
						}
					})
				}

			}
		};

		vm.changeValidateEntryAge = function(riderConfig, numLa,riderConfigRules) {
			// vm.proposal.laList[laRiderConfig.numLa].customer.dob;
			var dob = new Date(vm.proposal.laList[numLa].customer.dob)
					.getTime();
			if (riderConfig.code == 'KID1' || riderConfig.code == 'KID2'
					|| riderConfig.code == 'KID3'
					|| riderConfig.code == 'KID4'
					|| riderConfig.code == 'KID5'
					|| riderConfig.code == 'KID6'
					|| riderConfig.code == 'KID7'
					|| riderConfig.code == 'KID8'
					|| riderConfig.code == 'KID9'
					|| riderConfig.code == 'CIR4'
					|| riderConfig.code == 'ADD6') {
				FileTemplateService
						.get(
								{
									uri : 'validateEntryAge',
									birthMsDate : dob
								},
								function(result) {
									if (result !== null) {
										if (result.age < 30) {
											self
													.addAlert(
															'Người được bảo hiểm chưa đủ tuổi tham gia sản phẩm.',
															'danger');
											riderConfig.checked = false;
										} else {
											$scope.clearMessage();
										}
									} else {
										$scope.clearMessage();
									}
								})
			} else {
				self.clearMessage();
				vm.validDsrOpw = true;
				if(riderConfig.code == 'UHC4' && vm.proposal.contractType == 'UR7') {
					var component = {
							'option' : '',
							'sumAssured' : 0
						}
					riderConfig.component = component;
					riderConfig.component.option = riderConfig.optionValueList[0];
				}
				if (riderConfigRules != undefined && riderConfigRules.length > 0) {
					var ckDSR1,ckDSR2,ckOPW1,ckOPW3,ckOPW8,ckHCR1,ckHSR4,ckHRI1, ckUHS4, ckUHC4, ckHCR3 = false;
					var indexDSR1,indexDSR2,indexOPW1,indexOPW3,indexOPW8 = -1;
					for (var i = 0, length = riderConfigRules.length; i < length; i++) {
						if (riderConfigRules[i].code == 'DSR1') {
							if(riderConfigRules[i].checked) ckDSR1 = true;
							indexDSR1 = i;
						}
						if (riderConfigRules[i].code == 'DSR2') {
							if(riderConfigRules[i].checked) ckDSR2 = true;
							indexDSR2 = i;
						}
						if (riderConfigRules[i].code == 'OPW1') {
							if(riderConfigRules[i].checked) ckOPW1 = true; 
							indexOPW1 = i;
						}
						if (riderConfigRules[i].code == 'OPW3') {
							if(riderConfigRules[i].checked) ckOPW3 = true;
							indexOPW3 = i;
						}
						if (riderConfigRules[i].code == 'OPW8') {
							if(riderConfigRules[i].checked) ckOPW8 = true;
							indexOPW8 = i;
						}
						if (riderConfigRules[i].code == 'HCR1') {
							if(riderConfigRules[i].checked) {
								ckHCR1 = true;
							}
						}
						if (riderConfigRules[i].code == 'HCR3') {
							if(riderConfigRules[i].checked) {
								ckHCR3 = true;
							}
						}
						
						if (riderConfigRules[i].code == 'HSR4') {
							if(riderConfigRules[i].checked) {
								ckHSR4 = true;
							}
						}
						
						if (riderConfigRules[i].code == 'HRI1') {
							if(riderConfigRules[i].checked) {
								ckHRI1 = true;
							}
						}
						
						if (riderConfigRules[i].code == 'UHS4') {
							if(riderConfigRules[i].checked) {
								ckUHS4 = true;
							}
						}
						
						if (riderConfigRules[i].code == 'UHC4') {
							if(riderConfigRules[i].checked) {
								ckUHC4 = true;
							}
						}
					}
					
					if (ckHCR1 && (ckHSR4 || ckHRI1)) {
						var msg = '';
						msg = 'Sản phẩm [HCR1] không mua kèm với sản phẩm [HSR4] và [HRI1].';
						vm.validDsrOpw = false;
						vm.msgDsrOpw = msg;
						self.addAlert( msg, 'danger');
						return;	
					}
					
//					if (ckUHS4 && ckUHC4) {
//						var msg = '';
//						msg = 'Sản phẩm [UHS4] không mua kèm với sản phẩm [UHC4].';
//						vm.validDsrOpw = false;
//						vm.msgDsrOpw = msg;
//						self.addAlert( msg, 'danger');
//						return;	
//					}
					
					if((ckHCR1 && ckHCR3) || (ckHCR1 && ckUHS4) || (ckHCR3 && ckUHS4) || (ckHCR1 && ckHCR3 && ckUHS4)) {
						var msg = '';
						msg = 'Sản phẩm [UHS4] không mua kèm với sản phẩm [HCR1] và [HCR3].';
						vm.validDsrOpw = false;
						vm.msgDsrOpw = msg;
						self.addAlert( msg, 'danger');
						return;
					}
					
					//check when click
					/*if(ckDSR1 && ckDSR2) {
						var msg = '';
						msg = 'Sản phẩm phải mua kèm là: [DSR1/DSR2] mua [OPW8] ';
						vm.validDsrOpw = false;
						vm.msgDsrOpw = msg;
						self.addAlert( msg, 'danger');
						return;
					}
					if(ckDSR1) {
						var msg = '';
						if((!ckOPW1 && !ckOPW8) || (ckOPW1 && ckOPW8)) {
							msg = 'Sản phẩm [DSR1] phải mua kèm với sản phẩm [OPW8]';
							vm.validDsrOpw = false;
							vm.msgDsrOpw = msg;
							self.addAlert( msg, 'danger');
							return;
						}
					}
					if(ckDSR2) {
						var msg = '';
						if((!ckOPW3 && !ckOPW8) || (ckOPW3 && ckOPW8)) {
							msg = 'Sản phẩm [DSR2] phải mua kèm với sản phẩm [OPW8]';
							vm.validDsrOpw = false;
							vm.msgDsrOpw = msg;
							self.addAlert( msg, 'danger');
							return;
						}
					}*/
				}
			}
		};
		
		vm.getPremiumTermByPolicyTerm = function(riderConfigRule, numLa, index, policyTerm) {
			/*if(riderConfigRule.code == 'OPW8' && policyTerm != '' && policyTerm != undefined) {
				if(vm.listLaRiderConfig[numLa] != null && vm.listLaRiderConfig[numLa].riderConfigRules[index] != null && vm.listLaRiderConfig[numLa].riderConfigRules[index].component != null)
					vm.listLaRiderConfig[numLa].riderConfigRules[index].component.premiumTerm = policyTerm;
			}*/
		}

		vm.loadQuanHeWithGender = function() {
			for (var i = 0, length = vm.proposal.laList.length; i < length; i++) {
				vm.proposal.laList[i].relationshipCode = '';
				vm.loadQuanHe(i + 1);
			}							
		};

		vm.loadListQuestion6th = function() {
			FileTemplateService.query({
				uri : 'getListQuestion6th',
				questionCode : '0005'
			}, function(result) {
				vm.list6 = result;

			});
		};

		vm.loadListQuestion7th = function() {
			FileTemplateService.query({
				uri : 'getListQuestion7th',
				questionCode : '0006'
			}, function(result) {
				vm.list7 = result;

			});
		};

		/*
		 * vm.loadListQuestion8th = function() { FileTemplateService.query({ uri :
		 * 'getListQuestion8th', questionCode : '0007' }, function(result) {
		 * vm.list8 = result;
		 * 
		 * }); };
		 */

		vm.addNewChoice = function(la) {
			if (la == 0) {
				if (vm.choices1.length < 4) {
					var lenghItem = vm.choices1.length + 1;
					var subItem = lenghItem + lenghItem + 1;
					vm.choices1.push({
						'answer' : 'Y',
						'additionalInfo' : null,
						'questionSeq' : 8,
						'subQuestionSeq' : subItem,
						'choice.additionalSubQuestionSeq' : ''
					});
				}
			}
			if (la == 1) {
				if (vm.choices2.length < 4) {
					var lenghItem = vm.choices2.length + 1;
					var subItem = lenghItem + lenghItem + 1;
					vm.choices2.push({
						'answer' : 'Y',
						'additionalInfo' : null,
						'questionSeq' : 8,
						'subQuestionSeq' : subItem,
						'choice.additionalSubQuestionSeq' : ''
					});
				}
			}
			if (la == 2) {
				if (vm.choices3.length < 4) {
					var lenghItem = vm.choices3.length + 1;
					var subItem = lenghItem + lenghItem + 1;
					vm.choices3.push({
						'answer' : 'Y',
						'additionalInfo' : null,
						'questionSeq' : 8,
						'subQuestionSeq' : subItem,
						'choice.additionalSubQuestionSeq' : ''
					});
				}
			}
			if (la == 3) {
				if (vm.choices4.length < 4) {
					var lenghItem = vm.choices4.length + 1;
					var subItem = lenghItem + lenghItem + 1;
					vm.choices4.push({
						'answer' : 'Y',
						'additionalInfo' : null,
						'questionSeq' : 8,
						'subQuestionSeq' : subItem,
						'choice.additionalSubQuestionSeq' : ''
					});
				}
			}
		};

		vm.removeChoice = function(la) {
			if (la == 0) {
				var lastItem = vm.choices1.length - 1;
				vm.choices1.splice(lastItem);
			}
			if (la == 1) {
				var lastItem = vm.choices2.length - 1;
				vm.choices2.splice(lastItem);
			}
			if (la == 2) {
				var lastItem = vm.choices3.length - 1;
				vm.choices3.splice(lastItem);
			}
			if (la == 3) {
				var lastItem = vm.choices4.length - 1;
				vm.choices4.splice(lastItem);
			}
		};

		vm.resetChoice = function(la) {
			if (la == 0) {
				vm.choices1 = [];
			}
			if (la == 1) {
				vm.choices2 = [];
			}
			if (la == 2) {
				vm.choices3 = [];
			}
			if (la == 3) {
				vm.choices4 = [];
			}
		};

		vm.setQuestion8 = function() {
			if (vm.choices1.length > 0) {
				var index = 37
				for (var i = 0; i < vm.choices1.length; i++) {
					if (vm.choices1[i] != null) {
						index = index + i;
						vm.proposal.laList[0].questionnaireList[index] = vm.choices1[i];
					} else {
						vm.choices1.remove(vm.choices1[i]);
					}

				}

			}
			if (vm.choices2.length > 0) {
				var index = 37
				for (var i = 0; i < vm.choices2.length; i++) {
					if (vm.choices2[i] != null) {
						index = index + i;
						vm.proposal.laList[1].questionnaireList[index] = vm.choices2[i];
					} else {
						vm.choices2.remove(vm.choices2[i]);
					}
				}

			}
			if (vm.choices3.length > 0) {
				var index = 37
				for (var i = 0; i < vm.choices3.length; i++) {
					if (vm.choices3[i] != null) {
						index = index + i;
						vm.proposal.laList[2].questionnaireList[index] = vm.choices3[i];
					} else {
						vm.choices3.remove(vm.choices3[i]);
					}

				}

			}
			if (vm.choices4.length > 0) {
				var index = 37
				for (var i = 0; i < vm.choices4.length; i++) {
					if (vm.choices4[i] != null) {
						index = index + i;
						vm.proposal.laList[3].questionnaireList[index] = vm.choices4[i];
					} else {
						vm.choices4.remove(vm.choices4[i]);
					}

				}

			}
		};

		vm.loadquestion8 = function() {
			for (var i = 0; i < vm.proposal.laList.length; i++) {
				for (var j = 0; j < vm.proposal.laList[i].questionnaireList.length; j++) {
					if (vm.proposal.laList[i].questionnaireList[j] != null
							&& vm.proposal.laList[i].questionnaireList[j].questionSeq == 8
							&& j != 19 && i == 0) {
						vm.choices1
								.push(vm.proposal.laList[i].questionnaireList[j]);
					}
					if (vm.proposal.laList[i].questionnaireList[j] != null
							&& vm.proposal.laList[i].questionnaireList[j].questionSeq == 8
							&& j != 19 && i == 1) {
						vm.choices2
								.push(vm.proposal.laList[i].questionnaireList[j]);
					}
					if (vm.proposal.laList[i].questionnaireList[j] != null
							&& vm.proposal.laList[i].questionnaireList[j].questionSeq == 8
							&& j != 19 && i == 2) {
						vm.choices3
								.push(vm.proposal.laList[i].questionnaireList[j]);
					}
					if (vm.proposal.laList[i].questionnaireList[j] != null
							&& vm.proposal.laList[i].questionnaireList[j].questionSeq == 8
							&& j != 19 && i == 3) {
						vm.choices4
								.push(vm.proposal.laList[i].questionnaireList[j]);
					}
				}
			}
		}

		vm.checkPrefixOccupationRD = function(code, index) {
			if (code != undefined && code != '') {
				var str = code.substring(0, 1);
				if (str == 'R' || str == 'D' || str == '4') {
					if (index == 4)
						vm.proposal.po.customer.occupationClass = '4';
					else
						vm.proposal.laList[index].customer.occupationClass = '4';
				} else if (str == '1') {
					if (index == 4)
						vm.proposal.po.customer.occupationClass = '1';
					else
						vm.proposal.laList[index].customer.occupationClass = '1';
				} else if (str == '2') {
					if (index == 4)
						vm.proposal.po.customer.occupationClass = '2';
					else
						vm.proposal.laList[index].customer.occupationClass = '2';
				} else if (str == '3') {
					if (index == 4)
						vm.proposal.po.customer.occupationClass = '3';
					else
						vm.proposal.laList[index].customer.occupationClass = '3';
				}
			}
		}

		vm.getInfoFromRelationShipType = function(code, index) {
			if (code != null && code != undefined && code != '') {
				var lastName, firstName, gender, idNum, dob, street, nationality = null,otherNationality = null, otherStreet = null;
				switch (code) {
				case 'BMBH':
					lastName = vm.proposal.po.customer.lastName;
					firstName = vm.proposal.po.customer.firstName;
					gender = vm.proposal.po.customer.gender;
					idNum = vm.proposal.po.customer.idNum;
					dob = vm.proposal.po.customer.dob;
					street = vm.proposal.po.customer.street;
					nationality = vm.proposal.po.customer.nationality;
					otherNationality = vm.proposal.po.customer.otherNationality;
					otherStreet = vm.proposal.po.addressOther;
					break;
				case 'NDBHC':
					lastName = vm.proposal.laList[0].customer.lastName;
					firstName = vm.proposal.laList[0].customer.firstName;
					gender = vm.proposal.laList[0].customer.gender;
					idNum = vm.proposal.laList[0].customer.idNum;
					dob = vm.proposal.laList[0].customer.dob;
					street = vm.proposal.laList[0].customer.street;
					nationality = vm.proposal.laList[0].customer.nationality;
					otherNationality = vm.proposal.laList[0].customer.otherNationality;
					otherStreet = vm.proposal.laList[0].customer.foreignAddress;
					break;
				case 'NDBHBS1':
					lastName = vm.proposal.laList[1].customer.lastName;
					firstName = vm.proposal.laList[1].customer.firstName;
					gender = vm.proposal.laList[1].customer.gender;
					idNum = vm.proposal.laList[1].customer.idNum;
					dob = vm.proposal.laList[1].customer.dob;
					street = vm.proposal.laList[1].customer.street;
					nationality = vm.proposal.laList[1].customer.nationality;
					otherNationality = vm.proposal.laList[1].customer.otherNationality;
					otherStreet = vm.proposal.laList[1].customer.foreignAddress;
					break;
				case 'NDBHBS2':
					lastName = vm.proposal.laList[2].customer.lastName;
					firstName = vm.proposal.laList[2].customer.firstName;
					gender = vm.proposal.laList[2].customer.gender;
					idNum = vm.proposal.laList[2].customer.idNum;
					dob = vm.proposal.laList[2].customer.dob;
					street = vm.proposal.laList[2].customer.street;
					nationality = vm.proposal.laList[2].customer.nationality;
					otherNationality = vm.proposal.laList[2].customer.otherNationality;
					otherStreet = vm.proposal.laList[2].customer.foreignAddress;
					break;
				case 'NDBHBS3':
					lastName = vm.proposal.laList[3].customer.lastName;
					firstName = vm.proposal.laList[3].customer.firstName;
					gender = vm.proposal.laList[3].customer.gender;
					idNum = vm.proposal.laList[3].customer.idNum;
					dob = vm.proposal.laList[3].customer.dob;
					street = vm.proposal.laList[3].customer.street;
					nationality = vm.proposal.laList[3].customer.nationality;
					otherNationality = vm.proposal.laList[3].customer.otherNationality;
					otherStreet = vm.proposal.laList[3].customer.foreignAddress;
					break;
				case 'KHAC':
					gender = 'M';
					nationality = 'VN';
					break;
				default:
					break;
				}
				vm.proposal.benList[index].customer.lastName = lastName;
				vm.proposal.benList[index].customer.firstName = firstName;
				vm.proposal.benList[index].customer.gender = gender;
				vm.proposal.benList[index].customer.idNum = idNum;
				vm.proposal.benList[index].customer.dob = dob;
				vm.proposal.benList[index].customer.street = street;
				vm.proposal.benList[index].customer.nationality = nationality;
				vm.proposal.benList[index].customer.otherNationality = otherNationality;
				vm.proposal.benList[index].customer.foreignAddress = otherStreet;
				vm.benCMNDPage4(index);
			}
		}

		// upload multiple files
		vm.chooseUploadFiles = function(file, paperType) {
			if (file) {
				$scope.clearMessage();
				if (!vm.proposal.paperType) {
					self
							.addAlert(
									'Vui lòng chọn loại giấy tờ trước khi đính kèm file.',
									'danger');
					return;
				}
				var obj = {
					'file' : file,
					'paperType' : paperType,
					'paperTypeName' : getNameDropDownList(paperType),
					'archiveDataId' : 0
				}
				if (vm.filesByPaperType.length >= 5)
					self.addAlert('Tối đa chỉ được đính kèm 5 file.', 'danger');
				else
					vm.filesByPaperType.push(obj);
				vm.file = null;
				vm.proposal.paperType = null;
			}
		};

		$scope.$watch('vm.file', function() {
			if (vm.proposal)
				vm.chooseUploadFiles(vm.file, vm.proposal.paperType);
		});

		function getNameDropDownList(paperTypeCode) {
			for (var i = 0; i < vm.paperTypes.length; i++) {
				if (vm.paperTypes[i].code == paperTypeCode) {
					return vm.paperTypes[i].name;
				}
			}
			return null;
		}

		vm.removeFile = function(index) {
			if (vm.filesByPaperType.length > 0
					&& vm.filesByPaperType[index].file.archiveDataId != undefined
					&& vm.filesByPaperType[index].file.archiveDataId != 0) {
				FileTemplateService
						.get(
								{
									uri : 'remove-archive-data',
									archiveDataId : vm.filesByPaperType[index].file.archiveDataId
								}, function() {
									vm.filesByPaperType.splice(index, 1);
									$scope.loading = false;
								}, function() {
									$scope.loading = false;
								});
			} else {
				vm.filesByPaperType.splice(index, 1);
			}
		};

		vm.copyStreet = function(value) {
			if (value != null && value != undefined && value != '') {
				vm.proposal.laList[0].customer.street = value;
				vm.proposal.laList[1].customer.street = value;
				vm.proposal.laList[2].customer.street = value;
				vm.proposal.laList[3].customer.street = value;
			} else {
				vm.proposal.laList[0].customer.street = null;
				vm.proposal.laList[1].customer.street = null;
				vm.proposal.laList[2].customer.street = null;
				vm.proposal.laList[3].customer.street = null;
			}
		}

		vm.copyResidentCountryCode = function(value) {
			if (value != null && value != undefined && value != '') {
				vm.proposal.laList[0].customer.residentCountryCode = value;
				vm.proposal.laList[1].customer.residentCountryCode = value;
				vm.proposal.laList[2].customer.residentCountryCode = value;
				vm.proposal.laList[3].customer.residentCountryCode = value;
			} else {
				vm.proposal.laList[0].customer.residentCountryCode = null;
				vm.proposal.laList[1].customer.residentCountryCode = null;
				vm.proposal.laList[2].customer.residentCountryCode = null;
				vm.proposal.laList[3].customer.residentCountryCode = null;
			}
		}

		vm.copyProvinceLA = function(value) {
			if (vm.proposal.checkAllDisable != null
					&& vm.proposal.checkAllDisable != undefined
					&& !vm.proposal.checkAllDisable) {
				if (value != null && value != undefined && value != '') {
					vm.provinceMainLA = value;
					vm.provincesubLA = value;
					vm.provincethirdLA = value;
					vm.provincefourthLA = value;
				} else {
					vm.provinceMainLA = null;
					vm.provincesubLA = null;
					vm.provincethirdLA = null;
					vm.provincefourthLA = null;
					//
					vm.districtMainLA = null;
					vm.districtsubLA = null;
					vm.districtthirdLA = null;
					vm.districtfourthLA = null;
					//
					vm.proposal.laList[0].customer.locationCode = null;
					vm.proposal.laList[1].customer.locationCode = null;
					vm.proposal.laList[2].customer.locationCode = null;
					vm.proposal.laList[3].customer.locationCode = null;
				}
			}
		}

		vm.copyDistrictLA = function(value) {
			if (vm.proposal.checkAllDisable != null
					&& vm.proposal.checkAllDisable != undefined
					&& !vm.proposal.checkAllDisable) {
				if (value != null && value != undefined && value != '') {
					vm.districtMainLA = value;
					vm.districtsubLA = value;
					vm.districtthirdLA = value;
					vm.districtfourthLA = value;
				} else {
					vm.districtMainLA = null;
					vm.districtsubLA = null;
					vm.districtthirdLA = null;
					vm.districtfourthLA = null;
					//
					vm.proposal.laList[0].customer.locationCode = null;
					vm.proposal.laList[1].customer.locationCode = null;
					vm.proposal.laList[2].customer.locationCode = null;
					vm.proposal.laList[3].customer.locationCode = null;
				}
			}
		}

		vm.copyWardLA = function(value) {
			if (vm.proposal.checkAllDisable != null
					&& vm.proposal.checkAllDisable != undefined
					&& !vm.proposal.checkAllDisable) {
				if (value != null && value != undefined && value != '') {
					vm.proposal.laList[0].customer.locationCode = value;
					vm.proposal.laList[1].customer.locationCode = value;
					vm.proposal.laList[2].customer.locationCode = value;
					vm.proposal.laList[3].customer.locationCode = value;
				} else {
					vm.proposal.laList[0].customer.locationCode = null;
					vm.proposal.laList[1].customer.locationCode = null;
					vm.proposal.laList[2].customer.locationCode = null;
					vm.proposal.laList[3].customer.locationCode = null;
				}
			}
		}

		vm.banks = [];
		vm.getBanks = function() {
			CommonService.query({
				masterurl : 'get-all-bank-las'
			}, function(result) {
				vm.banks = result;
			});
		};

		vm.branchs = [];
		vm.getBranchBank = function() {
			if (vm.proposal.po.bankAccountCode != undefined
					&& vm.proposal.po.bankAccountCode != null
					&& vm.proposal.po.bankAccountCode != '') {
				CommonService.query({
					masterurl : 'get-all-branch-las',
					bankCode : vm.proposal.po.bankAccountCode
				}, function(result) {
					vm.branchs = result;
				});
			}
		};

		vm.getBankAccountName = function(item) {
			if (item != undefined && item != null && item != '') {
				vm.proposal.po.bankAccountName = item;
			}
		};

		vm.getbranchAccountName = function(item) {
			if (item != undefined && item != null && item != '') {
				vm.proposal.po.branchAccountName = item;
			}
		};
		
		self.messageAlertSumAssure = '';
		
		vm.checkSumAssure = function(index, numLa) {
			var riderConfig = vm.listLaRiderConfig[numLa].riderConfigRules[index];
			if (riderConfig.checked && (riderConfig.code == 'UCI2' || riderConfig.code == 'VCI2'
					|| riderConfig.code == 'CIR3' || riderConfig.code == 'UAB2'
					|| riderConfig.code == 'UAD3') ) {
				
				if(parseFloat(riderConfig.component.sumAssured) < 100000000) {
					self.messageAlertSumAssure = 'Số tiền BH phải lớn hơn hoặc bằng 100 triệu';
					riderConfig.component.sumAssured = '';
				}
			} else {
				self.messageAlertSumAssure = 'Số tiền BH phải lớn hơn 1 triệu';
			}
			
		};
	}

})();
